export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type AddOn = {
  __typename?: 'AddOn';
  billingStatus?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['String']>;
  dateLastBilled?: Maybe<Scalars['String']>;
  dateRemoved?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextBillDate?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

export type AddonParentProducts = {
  __typename?: 'AddonParentProducts';
  parentName?: Maybe<Scalars['String']>;
  parentProductKey?: Maybe<Scalars['String']>;
};

export type AppOffering = {
  __typename?: 'AppOffering';
  edition?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  pricingPlanKey?: Maybe<Scalars['String']>;
  pricingType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trialLengthInDays?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type AppOfferingPriceArgs = {
  count?: InputMaybe<Scalars['String']>;
};

export type AuditNote = {
  __typename?: 'AuditNote';
  author?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  revisionNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type AuditNoteConnection = Connection & {
  __typename?: 'AuditNoteConnection';
  edges?: Maybe<Array<Maybe<AuditNoteEdge>>>;
  nodes?: Maybe<Array<Maybe<AuditNote>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AuditNoteEdge = Edge & {
  __typename?: 'AuditNoteEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<AuditNote>;
};

export type Author = {
  __typename?: 'Author';
  isCustomerAdvocate?: Maybe<Scalars['Boolean']>;
  isSystemDrivenAction?: Maybe<Scalars['Boolean']>;
  statusSetBy?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  subjectType?: Maybe<Scalars['String']>;
};

export type AvailablePromotionRequest = {
  currency?: InputMaybe<Scalars['String']>;
  cycleInterval?: InputMaybe<Scalars['String']>;
  offeringRelationship?: InputMaybe<Array<InputMaybe<OfferingRelationship>>>;
  partnerStatus?: InputMaybe<PartnerStatus>;
  pricingType?: InputMaybe<Scalars['String']>;
  productKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Benefit = {
  __typename?: 'Benefit';
  benefitType?: Maybe<Scalars['String']>;
  customisable?: Maybe<BenefitCustomisableObj>;
  duration?: Maybe<Scalars['String']>;
  iterations?: Maybe<Scalars['Int']>;
  scale?: Maybe<Scalars['String']>;
  subBenefitType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
  values?: Maybe<Array<Maybe<BenefitsValueObj>>>;
};

export type BenefitCustomisableObj = {
  __typename?: 'BenefitCustomisableObj';
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  iterations?: Maybe<BenefitCustomisableValue>;
  value?: Maybe<BenefitCustomisableValue>;
};

export type BenefitCustomisableValue = {
  __typename?: 'BenefitCustomisableValue';
  lowerBound?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  upperBound?: Maybe<Scalars['Float']>;
};

export type BenefitsValueObj = {
  __typename?: 'BenefitsValueObj';
  appliedOn?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type BillTo = {
  __typename?: 'BillTo';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIds?: Maybe<Array<Maybe<BillToTaxItems>>>;
};

export type BillToTaxItems = {
  __typename?: 'BillToTaxItems';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  taxExempt?: Maybe<Scalars['Boolean']>;
  taxIdDescription?: Maybe<Scalars['String']>;
  taxIdLabel?: Maybe<Scalars['String']>;
};

export type BillingAnchor = {
  __typename?: 'BillingAnchor';
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export enum BillingFrequency {
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  OTHER = 'OTHER',
}

export type BlendedComputation = {
  __typename?: 'BlendedComputation';
  blendedMargin?: Maybe<Scalars['Int']>;
  currentGLP?: Maybe<Scalars['Int']>;
  newGlp?: Maybe<Scalars['Int']>;
  previousGlp?: Maybe<Scalars['Int']>;
  renewPercentage?: Maybe<Scalars['String']>;
  renewalMargin?: Maybe<Scalars['Int']>;
  renewalValue?: Maybe<Scalars['Int']>;
  upsellMargin?: Maybe<Scalars['Int']>;
  upsellPercentage?: Maybe<Scalars['String']>;
  upsellValue?: Maybe<Scalars['Int']>;
};

export type CancelledReason = {
  __typename?: 'CancelledReason';
  code?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  lastUpdatedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Scalars['String']>;
};

export type Cardinality = {
  __typename?: 'Cardinality';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type CatalogueAddonParentProduct = {
  __typename?: 'CatalogueAddonParentProduct';
  parentName?: Maybe<Scalars['String']>;
  parentProductKey?: Maybe<Scalars['String']>;
};

export type CatalogueAppOffering = {
  __typename?: 'CatalogueAppOffering';
  edition?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  pricingPlanKey?: Maybe<Scalars['String']>;
  pricingType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trialLengthInDays?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type CatalogueAppOfferingPriceArgs = {
  count?: InputMaybe<Scalars['String']>;
};

export type CatalogueProduct = {
  __typename?: 'CatalogueProduct';
  addonParentProducts?: Maybe<Array<Maybe<CatalogueAddonParentProduct>>>;
  availablePromotions?: Maybe<Array<Maybe<PartnerPromotion>>>;
  baseProduct?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  dataSources?: Maybe<ProductDataSource>;
  description?: Maybe<Scalars['String']>;
  editions?: Maybe<Array<Maybe<ProductEdition>>>;
  hasOptedInForPartnerPromotion?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isApp?: Maybe<Scalars['Boolean']>;
  isEnabledForOrder?: Maybe<Scalars['Boolean']>;
  isProduct?: Maybe<Scalars['Boolean']>;
  logoId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offering?: Maybe<Array<Maybe<ProductOffering>>>;
  plans?: Maybe<Array<Maybe<CatalogueProductPlans>>>;
  platform?: Maybe<ProductPlatform>;
  productFamily?: Maybe<Scalars['String']>;
  productType?: Maybe<CatalogueProductType>;
  public?: Maybe<Scalars['Boolean']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<ProductUnitLabel>;
  updatedDate?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type CatalogueProductAvailablePromotionsArgs = {
  filterPromotions?: InputMaybe<AvailablePromotionRequest>;
};

export type CatalogueProductOfferingArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
};

export type CatalogueProductConnection = Connection & {
  __typename?: 'CatalogueProductConnection';
  edges: Array<Maybe<CatalogueProductEdge>>;
  nodes: Array<Maybe<CatalogueProduct>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CatalogueProductEdge = Edge & {
  __typename?: 'CatalogueProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<CatalogueProduct>;
};

export type CatalogueProductPlans = {
  __typename?: 'CatalogueProductPlans';
  id?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  periodUnit?: Maybe<Scalars['String']>;
  priceUpdated?: Maybe<Scalars['String']>;
  pricingPlanType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
};

export enum CatalogueProductType {
  ADDON = 'ADDON',
  BTF_SUBSCRIPTION = 'BTF_SUBSCRIPTION',
  HOSTED = 'HOSTED',
  HOSTED_ADDON = 'HOSTED_ADDON',
  HYBRID_SUBSCRIPTION = 'HYBRID_SUBSCRIPTION',
  ON_DEMAND_ADDON = 'ON_DEMAND_ADDON',
  PERPETUAL = 'PERPETUAL',
  PERPETUAL_PRICING_PLAN = 'PERPETUAL_PRICING_PLAN',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUBSCRIPTION_ADDON = 'SUBSCRIPTION_ADDON',
  TRAINING = 'TRAINING',
  UNIVERSITY = 'UNIVERSITY',
}

export type ChargeElement = {
  __typename?: 'ChargeElement';
  data: ChargeElementData;
  type: Scalars['String'];
};

export type ChargeElementData = {
  __typename?: 'ChargeElementData';
  ceiling: Scalars['Int'];
};

export type ChargeQuantity = {
  __typename?: 'ChargeQuantity';
  chargeElement?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type ChargeQuantityInput = {
  chargeElement?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type CloneOptions = {
  quoteCloneTxaId?: InputMaybe<Scalars['String']>;
};

export type ClonedLineItemDetail = {
  __typename?: 'ClonedLineItemDetail';
  billingAnchor?: Maybe<BillingAnchor>;
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  endsAt?: Maybe<EndsAt>;
  entitlementId: Scalars['String'];
  entitlementVersion: Scalars['String'];
  lineItemId: Scalars['ID'];
  offeringKey?: Maybe<Scalars['String']>;
  preBillingConfiguration?: Maybe<PreBillingConfiguration>;
  pricingPlanId?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  relatesFromEntitlements?: Maybe<Array<Maybe<LineItemRelation>>>;
  startsAt?: Maybe<StartsAt>;
  termType?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ClonedQuote = {
  __typename?: 'ClonedQuote';
  createQuoteRequestPayload?: Maybe<CreateQuoteRequest>;
  lineItems?: Maybe<Array<Maybe<QuoteLineItem>>>;
  quoteCloneDetails?: Maybe<ClonedQuoteDetails>;
};

export type ClonedQuoteDetails = {
  __typename?: 'ClonedQuoteDetails';
  billingGroupId?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  expiryDate?: Maybe<Scalars['String']>;
  externalNotes?: Maybe<Array<Maybe<Notes>>>;
  fromQuote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalNotes?: Maybe<Array<Maybe<Notes>>>;
  invoiceGroup?: Maybe<InvoiceGroup>;
  metadata?: Maybe<QuoteMetaData>;
  name?: Maybe<Scalars['String']>;
  opportunityDetail?: Maybe<OpportunityDetails>;
  quoteAuthor?: Maybe<Scalars['String']>;
  quoteContact?: Maybe<Scalars['String']>;
  quoteNumber?: Maybe<Scalars['String']>;
  revisionNumber?: Maybe<Scalars['String']>;
  status?: Maybe<QuoteStatus>;
  transactionAccountId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type CompareToPlan = {
  __typename?: 'CompareToPlan';
  activationDate?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  pricePercentageDifference?: Maybe<Scalars['String']>;
};

/**
 * The connection model provides a standard mechanism for slicing and paginating the result set.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm)
 */
export type Connection = {
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Common parameters when searching for a connection and paginating (either by cursor or offset). Uses Hydra terminology by default. */
export type ConnectionSearchOptions = {
  after?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortType>;
};

export type Count = {
  __typename?: 'Count';
  count?: Maybe<Scalars['Int']>;
};

export type CreateQuoteRequest = {
  __typename?: 'CreateQuoteRequest';
  externalNotes?: Maybe<Array<Maybe<Notes>>>;
  id: Scalars['ID'];
  internalNotes?: Maybe<Array<Maybe<Notes>>>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<Array<Maybe<ClonedLineItemDetail>>>;
  metadata?: Maybe<QuoteMetaData>;
  name?: Maybe<Scalars['String']>;
  opportunityId?: Maybe<Scalars['String']>;
  quoteCustomerContacts?: Maybe<QuoteCustomerContacts>;
  testParameters?: Maybe<TestParameter>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export enum Currency {
  AUD = 'AUD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  USD = 'USD',
}

export enum CycleInterval {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export type DataSources = {
  __typename?: 'DataSources';
  sourceId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
};

/** Health of the graph by basic dependency checks */
export type DependencyHealth = {
  __typename?: 'DependencyHealth';
  key: Scalars['String'];
  label: Scalars['String'];
  successful: Scalars['Boolean'];
};

export type DiscountCategory = {
  __typename?: 'DiscountCategory';
  discountType?: Maybe<Scalars['String']>;
  discountValue?: Maybe<Scalars['Float']>;
};

export type DiscountDetails = {
  __typename?: 'DiscountDetails';
  discountAmount?: Maybe<Scalars['Float']>;
  discountType?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  promotionId?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
};

export type Dunning = {
  __typename?: 'Dunning';
  creditsWithInPaidPeriod?: Maybe<Scalars['Boolean']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  invoiceAmount?: Maybe<Scalars['Float']>;
  invoiceFrequency?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceRequestId?: Maybe<Scalars['String']>;
  isInvoiceWithCredits?: Maybe<Scalars['Boolean']>;
  openInvoiceOrderItemId?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Scalars['String']>;
  paidInvoiceDetails?: Maybe<PaidInvoiceDetails>;
  paymentMethodType?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['Float']>;
};

export type Duration = {
  __typename?: 'Duration';
  interval?: Maybe<Scalars['String']>;
  intervalCount?: Maybe<Scalars['String']>;
};

/**
 * A type that is returned in list form by a connection type’s edges field is considered by this spec to be an Edge Type. Edge types must be an “Object” as defined in the “Type System” section of the GraphQL Specification.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-Edges)
 */
export type Edge = {
  cursor?: Maybe<Scalars['ID']>;
};

export type Editions = {
  __typename?: 'Editions';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  skuId?: Maybe<Scalars['String']>;
};

export type EligibilityRule = {
  __typename?: 'EligibilityRule';
  currency?: Maybe<Array<Maybe<Scalars['String']>>>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  partnerTier?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnerType?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  saleTransitionType?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EndsAt = {
  __typename?: 'EndsAt';
  duration?: Maybe<Duration>;
  timestamp?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EstimateLineItemsList = {
  __typename?: 'EstimateLineItemsList';
  discountDetails?: Maybe<Array<Maybe<DiscountDetails>>>;
  marginDetails?: Maybe<Array<Maybe<Margins>>>;
};

export type ExistingEnterpriseInstanceDetails = {
  __typename?: 'ExistingEnterpriseInstanceDetails';
  cloudSiteId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
};

export type ExistingJiraProduct = {
  __typename?: 'ExistingJiraProduct';
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatesFromEntitlements>>>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type ExistingNonJiraProduct = {
  __typename?: 'ExistingNonJiraProduct';
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type ExistingProduct = {
  __typename?: 'ExistingProduct';
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<RelatesFromEntitlements>>>;
  sourceSystem?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type FilterOption = {
  and?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  key?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  or?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  value?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InvoiceGroup = {
  __typename?: 'InvoiceGroup';
  currency?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pricingEligibility?: Maybe<Scalars['String']>;
  purchaseOrder?: Maybe<PurchaseOrder>;
};

export type InvoicePromotionDetail = {
  __typename?: 'InvoicePromotionDetail';
  promotionDefinition?: Maybe<PromotionDefinition>;
  promotionInstanceId?: Maybe<Scalars['String']>;
};

export type LineItemEntitlement = {
  __typename?: 'LineItemEntitlement';
  activeUsers?: Maybe<Scalars['Int']>;
  billedUsers?: Maybe<Scalars['String']>;
  billingClockId?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  dunning?: Maybe<Dunning>;
  edition?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  entitlementId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  entitlementVersion?: Maybe<Scalars['Int']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  isPaid?: Maybe<Scalars['Boolean']>;
  isPrebilledEntitlement?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  legacyEntitlementId?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  maxOfferingUserCount?: Maybe<Scalars['Int']>;
  nextBillingTimestamp?: Maybe<Scalars['Float']>;
  nextBillingTimestampForScheduledUpgrades?: Maybe<Scalars['Float']>;
  offering?: Maybe<Offering>;
  offeringKey?: Maybe<Scalars['String']>;
  optedQuantities?: Maybe<Array<Maybe<OptedQuantity>>>;
  orgId?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  pauseBilling?: Maybe<PauseBilling>;
  preDunning?: Maybe<PreDunning>;
  prebillStartTimestamp?: Maybe<Scalars['Float']>;
  pricingPlan?: Maybe<PricingPlan>;
  pricingPlanId?: Maybe<Scalars['String']>;
  pricingType?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<LineItemRelation>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<LineItemRelation>>>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  transactionAccountId?: Maybe<Scalars['String']>;
  trial?: Maybe<Scalars['Boolean']>;
  trialDetails?: Maybe<LineItemEntitlementTrial>;
  trialEndDate?: Maybe<Scalars['String']>;
  upgradeTrial?: Maybe<UpgradeTrialDetails>;
};

export type LineItemEntitlementTrial = {
  __typename?: 'LineItemEntitlementTrial';
  endTimestamp?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['String']>;
};

export type LineItemOffering = {
  __typename?: 'LineItemOffering';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  pricingType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  relationshipRequirements?: Maybe<Array<Maybe<RelationshipRequirement>>>;
};

export type LineItemPricingPlan = {
  __typename?: 'LineItemPricingPlan';
  activatedWithReason?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<BillingFrequency>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pricingPlanType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<Maybe<PricePlanTiers>>>;
};

export type LineItemRelation = {
  __typename?: 'LineItemRelation';
  entitlementId?: Maybe<Scalars['String']>;
  lineItemId?: Maybe<Scalars['String']>;
  referenceType?: Maybe<Scalars['String']>;
  relationshipType?: Maybe<Scalars['String']>;
};

export type LinkedEnterprise = {
  __typename?: 'LinkedEnterprise';
  billedUsers?: Maybe<Scalars['String']>;
  endTimeStamp?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  pricingType?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<Maybe<PricePlanTiers>>>;
  trial?: Maybe<Scalars['Boolean']>;
  trialDetails?: Maybe<LineItemEntitlementTrial>;
  trialEndDate?: Maybe<Scalars['String']>;
};

export type Margins = {
  __typename?: 'Margins';
  amount?: Maybe<Scalars['Float']>;
  blended?: Maybe<Scalars['Boolean']>;
  blendedComputation?: Maybe<BlendedComputation>;
  endsAt?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['String']>;
  promoCode?: Maybe<Scalars['String']>;
  promotionId?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  taxAmount?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type MultiInstanceCatalog = {
  __typename?: 'MultiInstanceCatalog';
  ari: Scalars['String'];
  catalogAccountId: Scalars['ID'];
  chargeElements: Array<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['ID'];
  logoId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
  supportedBillingSystems: Array<Scalars['String']>;
  updatedAt: Scalars['Float'];
  version: Scalars['Int'];
};

export type MultiInstanceCatalogConnection = Connection & {
  __typename?: 'MultiInstanceCatalogConnection';
  edges: Array<Maybe<MultiInstanceCatalogEdge>>;
  nodes: Array<Maybe<MultiInstanceCatalog>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MultiInstanceCatalogEdge = Edge & {
  __typename?: 'MultiInstanceCatalogEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<MultiInstanceCatalog>;
};

export type Notes = {
  __typename?: 'Notes';
  id?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type Offering = {
  __typename?: 'Offering';
  availableAddOns?: Maybe<Array<Maybe<AddOn>>>;
  availableApps?: Maybe<Array<Maybe<AppOffering>>>;
  availablePricingPlans?: Maybe<Array<Maybe<PricingPlan>>>;
  chargeElements?: Maybe<Array<Maybe<ChargeElement>>>;
  dataSources?: Maybe<Array<Maybe<DataSources>>>;
  dependsOnOfferings?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  offeringId: Scalars['String'];
  offeringName?: Maybe<Scalars['String']>;
  offeringRelationShip?: Maybe<OfferingRelationshipObj>;
  pricing?: Maybe<Array<Maybe<Pricing>>>;
  pricingType?: Maybe<Scalars['String']>;
  product?: Maybe<OfferingProductDetails>;
  productCatalogId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  relationshipRequirements?: Maybe<Array<Maybe<RelationshipRequirement>>>;
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceSequence: Scalars['String'];
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  status: Status;
  toOfferingIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  trialLengthInDays?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type OfferingAvailableAppsArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
};

export type OfferingAvailablePricingPlansArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  queryDefaultPricingPlans?: InputMaybe<Scalars['Boolean']>;
};

export type OfferingProductDetails = {
  __typename?: 'OfferingProductDetails';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum OfferingRelationDirection {
  TO = 'TO',
}

export enum OfferingRelationType {
  APP_DEPENDENCE = 'APP_DEPENDENCE',
}

export type OfferingRelationship = {
  direction?: InputMaybe<OfferingRelationDirection>;
  type?: InputMaybe<OfferingRelationType>;
};

export type OfferingRelationshipObj = {
  __typename?: 'OfferingRelationshipObj';
  ari?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  from?: Maybe<RelationshipNode>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  offeringRelationshipType?: Maybe<Scalars['String']>;
  relationshipTemplateId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  to?: Maybe<RelationshipNode>;
  updatedAt?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export type OpportunityDetails = {
  __typename?: 'OpportunityDetails';
  accountRegion?: Maybe<Scalars['String']>;
  accountTerritory?: Maybe<Scalars['String']>;
  enterpriseAccountStatus?: Maybe<Scalars['String']>;
  enterpriseForecastCategory?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  opportunityId?: Maybe<Scalars['String']>;
  opportunityNumber?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  ownerAAID?: Maybe<Scalars['String']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  recordtypeName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OpportunityQuotes = {
  __typename?: 'OpportunityQuotes';
  quoteNumber?: Maybe<Scalars['String']>;
};

export type OpportunitySearchDetails = {
  __typename?: 'OpportunitySearchDetails';
  accountRegion?: Maybe<Scalars['String']>;
  accountTerritory?: Maybe<Scalars['String']>;
  enterpriseAccountStatus?: Maybe<Scalars['String']>;
  enterpriseForecastCategory?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  opportunityId?: Maybe<Scalars['String']>;
  opportunityNumber?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  ownerAAID?: Maybe<Scalars['String']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  quotes?: Maybe<Array<Maybe<OpportunityQuotes>>>;
  recordtypeName?: Maybe<Scalars['String']>;
  stageName?: Maybe<Scalars['String']>;
  stageReason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OptedQuantity = {
  __typename?: 'OptedQuantity';
  chargeElement?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
};

export enum OptedQuantitySource {
  CEILING_LIMIT = 'CEILING_LIMIT',
  INHERITED = 'INHERITED',
  USER_OPTED = 'USER_OPTED',
}

/**
 * Information about pagination in a connection
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo)
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
};

export type PaidInvoiceDetails = {
  __typename?: 'PaidInvoiceDetails';
  createdAt?: Maybe<Scalars['Float']>;
  endTimestamp?: Maybe<Scalars['Float']>;
  invoiceGroupId?: Maybe<Scalars['String']>;
  offeringKey?: Maybe<Scalars['String']>;
  prevBillingAnchorTimestamp?: Maybe<Scalars['Float']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  promotionDetails?: Maybe<Array<Maybe<InvoicePromotionDetail>>>;
  quantity?: Maybe<Scalars['Int']>;
  transactionAccountId?: Maybe<Scalars['String']>;
};

export type ParentEntitlementConnection = {
  __typename?: 'ParentEntitlementConnection';
  isAppCompatibleWithProduct?: Maybe<Scalars['Boolean']>;
};

export type PartnerDiscountDetails = {
  __typename?: 'PartnerDiscountDetails';
  partnerDiscounts?: Maybe<Array<Maybe<DiscountDetails>>>;
  totalPartnerDiscount?: Maybe<Scalars['Float']>;
};

export type PartnerPromotion = {
  __typename?: 'PartnerPromotion';
  applicationReason?: Maybe<PromotionReason>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
  customisableReasons?: Maybe<Array<Maybe<ReasonCustomisableObj>>>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  cycleIntervalWithEligibleConditions?: Maybe<Array<Maybe<Scalars['String']>>>;
  eligibilityRules?: Maybe<EligibilityRule>;
  isPromotionCustomisable?: Maybe<Scalars['Boolean']>;
  maxRedemptionsCustomer?: Maybe<Scalars['Int']>;
  maxRedemptionsPromotion?: Maybe<Scalars['Int']>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  promotionDefinition?: Maybe<PromotionDefinition>;
  promotionId?: Maybe<Scalars['String']>;
  promotionInstanceId?: Maybe<Scalars['String']>;
  promotionWindow?: Maybe<PromotionWindow>;
  purpose?: Maybe<Purpose>;
  rule?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PartnerSearchAppsProduct = {
  __typename?: 'PartnerSearchAppsProduct';
  appName?: Maybe<Scalars['String']>;
  hasOptedInForPartnerPromotion?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  logoId?: Maybe<Scalars['String']>;
  offering?: Maybe<Array<Maybe<ProductOffering>>>;
  offeringId?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  pricingPlanKey?: Maybe<Scalars['String']>;
  pricingType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trialLengthInDays?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type PartnerSearchAppsProductOfferingArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
};

export type PartnerSearchAppsProductsConnection = Connection & {
  __typename?: 'PartnerSearchAppsProductsConnection';
  edges?: Maybe<Array<Maybe<PartnerSearchAppsProduct>>>;
  nodes?: Maybe<Array<Maybe<PartnerSearchAppsProduct>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type PartnerStatus = {
  discountTier?: InputMaybe<Scalars['String']>;
  programLevelGlobal?: InputMaybe<Scalars['String']>;
};

export type PauseBilling = {
  __typename?: 'PauseBilling';
  endTimestamp?: Maybe<Scalars['Float']>;
  startTimestamp?: Maybe<Scalars['Float']>;
};

export type Period = {
  __typename?: 'Period';
  endsAt?: Maybe<Scalars['Float']>;
  startsAt?: Maybe<Scalars['Float']>;
};

export enum PeriodUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export type Plans = {
  __typename?: 'Plans';
  id?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  periodUnit?: Maybe<Scalars['String']>;
  priceUpdated?: Maybe<Scalars['String']>;
  pricingPlanType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
};

export enum Platform {
  CLOUD = 'CLOUD',
  DATA_CENTER = 'DATA_CENTER',
  SERVER = 'SERVER',
  TRAINING = 'TRAINING',
}

export type PreBillFrom = {
  __typename?: 'PreBillFrom';
  timestamp?: Maybe<Scalars['String']>;
  type?: Maybe<PreBillFromTypes>;
};

export enum PreBillFromTypes {
  QUOTE_ACCEPTANCE_DATE = 'QUOTE_ACCEPTANCE_DATE',
  TIMESTAMP = 'TIMESTAMP',
  UPCOMING_INVOICE = 'UPCOMING_INVOICE',
}

export type PreBillTo = {
  __typename?: 'PreBillTo';
  duration?: Maybe<Duration>;
  timestamp?: Maybe<Scalars['String']>;
  type?: Maybe<PreBillToTypes>;
};

export enum PreBillToTypes {
  DURATION = 'DURATION',
  TIMESTAMP = 'TIMESTAMP',
}

export type PreBillingConfiguration = {
  __typename?: 'PreBillingConfiguration';
  billFrom?: Maybe<PreBillFrom>;
  billTo?: Maybe<PreBillTo>;
};

export type PreDunning = {
  __typename?: 'PreDunning';
  associatedEntitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  endTimestamp?: Maybe<Scalars['Float']>;
  orderItemId?: Maybe<Scalars['String']>;
  predunningInvoiceIdentifier?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['Float']>;
};

export type PricePlanTiers = {
  __typename?: 'PricePlanTiers';
  amount?: Maybe<Scalars['Int']>;
  ceiling?: Maybe<Scalars['Int']>;
  flatAmount?: Maybe<Scalars['Int']>;
  floor?: Maybe<Scalars['Int']>;
  policy?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type PriceTier = {
  __typename?: 'PriceTier';
  prices?: Maybe<Array<Maybe<ProductPrice>>>;
  pricingStrategy?: Maybe<ProductPricingStrategy>;
  starter?: Maybe<Scalars['Boolean']>;
  unitDescription?: Maybe<Scalars['String']>;
  unitLimitLower?: Maybe<Scalars['String']>;
  unitLimitUpper?: Maybe<Scalars['String']>;
};

export type PriceTiers = {
  __typename?: 'PriceTiers';
  prices?: Maybe<Array<Maybe<Prices>>>;
  pricingStrategy?: Maybe<PricingStrategy>;
  starter?: Maybe<Scalars['Boolean']>;
  unitDescription?: Maybe<Scalars['String']>;
  unitLimitLower?: Maybe<Scalars['String']>;
  unitLimitUpper?: Maybe<Scalars['String']>;
};

export type Prices = {
  __typename?: 'Prices';
  currency?: Maybe<Currency>;
  flatAmount?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['String']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  dataSources?: Maybe<Array<Maybe<DataSources>>>;
  dunningPricing?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  periodCount: Scalars['String'];
  periodUnit: PeriodUnit;
  priceTiers?: Maybe<Array<Maybe<PriceTiers>>>;
  pricingPlanType: Scalars['String'];
  productCatalogItemId: Scalars['String'];
  productName: Scalars['String'];
  sourceId: Scalars['String'];
  sourceSequence?: Maybe<Scalars['String']>;
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  status: Status;
  transitionPricing?: Maybe<Scalars['String']>;
};

export type PricingChangeHistory = {
  __typename?: 'PricingChangeHistory';
  id?: Maybe<Scalars['String']>;
  previousPlan?: Maybe<CompareToPlan>;
  upcomingPlan?: Maybe<CompareToPlan>;
  userTier?: Maybe<Scalars['String']>;
};

export type PricingPlan = {
  __typename?: 'PricingPlan';
  activationDate?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  billingFrequency?: Maybe<BillingFrequency>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  offeringKey?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  pricingPlanType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<Maybe<PricePlanTiers>>>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type PricingPlanCatalogue = {
  __typename?: 'PricingPlanCatalogue';
  nextIdMap?: Maybe<Array<Maybe<NextId>>>;
  values?: Maybe<Array<Maybe<PricingPlan>>>;
};

export enum PricingStrategy {
  FIXED_COST = 'FIXED_COST',
  MARGINAL_PER_UNIT = 'MARGINAL_PER_UNIT',
  PER_UNIT = 'PER_UNIT',
}

export enum PricingType {
  EXTERNAL = 'EXTERNAL',
  FREE = 'FREE',
  LIMITED_FREE = 'LIMITED_FREE',
  PAID = 'PAID',
}

export type Product = {
  __typename?: 'Product';
  addonParentProducts?: Maybe<Array<Maybe<AddonParentProducts>>>;
  availablePromotions?: Maybe<Array<Maybe<Promotion>>>;
  baseProduct?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
  chargeElement?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  dataSources?: Maybe<DataSources>;
  description?: Maybe<Scalars['String']>;
  editions?: Maybe<Array<Maybe<Editions>>>;
  hasOptedInForPartnerPromotion?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isAddOn?: Maybe<Scalars['Boolean']>;
  isApp?: Maybe<Scalars['Boolean']>;
  logoId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offering?: Maybe<Array<Maybe<Offering>>>;
  offeringCollections?: Maybe<Array<Maybe<Offering>>>;
  plans?: Maybe<Array<Maybe<Plans>>>;
  platform?: Maybe<Platform>;
  productFamily?: Maybe<Scalars['String']>;
  productOfferingsForCollection?: Maybe<Array<Maybe<Offering>>>;
  productType?: Maybe<ProductType>;
  public?: Maybe<Scalars['Boolean']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<UnitLabel>;
  updatedDate?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type ProductAvailablePromotionsArgs = {
  id: Scalars['ID'];
};

export type ProductOfferingArgs = {
  enterpriseInstanceOffering?: InputMaybe<Scalars['Boolean']>;
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
};

export type ProductAddOn = {
  __typename?: 'ProductAddOn';
  billingStatus?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['String']>;
  dateLastBilled?: Maybe<Scalars['String']>;
  dateRemoved?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextBillDate?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

export type ProductConnection = Connection & {
  __typename?: 'ProductConnection';
  edges: Array<Maybe<ProductEdge>>;
  nodes: Array<Maybe<Product>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductDataSource = {
  __typename?: 'ProductDataSource';
  sourceId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
};

export type ProductEdge = Edge & {
  __typename?: 'ProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Product>;
};

export type ProductEdition = {
  __typename?: 'ProductEdition';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  skuId?: Maybe<Scalars['String']>;
};

export type ProductEligibility = {
  __typename?: 'ProductEligibility';
  isProductEligibleForCollection?: Maybe<Scalars['Boolean']>;
  isProductEligibleForMultiInstance?: Maybe<Scalars['Boolean']>;
};

export type ProductNote = {
  __typename?: 'ProductNote';
  entitlementId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

export type ProductOffering = {
  __typename?: 'ProductOffering';
  availableAddOns?: Maybe<Array<Maybe<ProductAddOn>>>;
  availableApps?: Maybe<Array<Maybe<CatalogueAppOffering>>>;
  availablePricingPlans?: Maybe<Array<Maybe<PricingPlan>>>;
  availableProducts?: Maybe<Array<Maybe<Scalars['String']>>>;
  chargeElements?: Maybe<Array<Maybe<ChargeElement>>>;
  dataSources?: Maybe<Array<Maybe<ProductDataSource>>>;
  dependsOnOfferings?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  level: Scalars['Int'];
  offeringGroup?: Maybe<Scalars['String']>;
  offeringId: Scalars['String'];
  offeringName?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<Maybe<ProductPricing>>>;
  pricingType?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  relationshipRequirements?: Maybe<Array<Maybe<RelationshipRequirement>>>;
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceSequence: Scalars['String'];
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  status: ProductStatus;
  trialLengthInDays?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type ProductOfferingAvailableAppsArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
};

export type ProductOfferingAvailablePricingPlansArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  queryDefaultPricingPlans?: InputMaybe<Scalars['Boolean']>;
};

export type ProductPageParams = {
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

export enum ProductPlatform {
  CLOUD = 'CLOUD',
  DATA_CENTER = 'DATA_CENTER',
  SERVER = 'SERVER',
  TRAINING = 'TRAINING',
}

export type ProductPrice = {
  __typename?: 'ProductPrice';
  currency?: Maybe<ProductPriceCurrency>;
  flatAmount?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['String']>;
};

export enum ProductPriceCurrency {
  AUD = 'AUD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  USD = 'USD',
}

export type ProductPricing = {
  __typename?: 'ProductPricing';
  dataSources?: Maybe<Array<Maybe<DataSources>>>;
  dunningPricing?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  periodCount: Scalars['String'];
  priceTiers?: Maybe<Array<Maybe<PriceTier>>>;
  pricingPlanType: Scalars['String'];
  productCatalogItemId: Scalars['String'];
  productName: Scalars['String'];
  sourceId: Scalars['String'];
  sourceSequence?: Maybe<Scalars['String']>;
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  status: ProductStatus;
  transitionPricing?: Maybe<Scalars['String']>;
};

export enum ProductPricingStrategy {
  FIXED_COST = 'FIXED_COST',
  MARGINAL_PER_UNIT = 'MARGINAL_PER_UNIT',
  PER_UNIT = 'PER_UNIT',
}

export enum ProductStatus {
  ACTIVE = 'ACTIVE',
  AT_NOTICE = 'AT_NOTICE',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  GRANDFATHERED = 'GRANDFATHERED',
}

export enum ProductType {
  ADDON = 'ADDON',
  BTF_SUBSCRIPTION = 'BTF_SUBSCRIPTION',
  HOSTED = 'HOSTED',
  HOSTED_ADDON = 'HOSTED_ADDON',
  HYBRID_SUBSCRIPTION = 'HYBRID_SUBSCRIPTION',
  ONDEMAND_ADDON = 'ONDEMAND_ADDON',
  PERPETUAL = 'PERPETUAL',
  PERPETUAL_PRICING_PLAN = 'PERPETUAL_PRICING_PLAN',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUBSCRIPTION_ADDON = 'SUBSCRIPTION_ADDON',
  TRAINING = 'TRAINING',
  UNIVERSITY = 'UNIVERSITY',
}

export enum ProductUnitLabel {
  AGENT = 'AGENT',
  MACHINE = 'MACHINE',
  MANAGER = 'MANAGER',
  NONE = 'NONE',
  REMOTE_AGENT = 'REMOTE_AGENT',
  TRAINING_CREDIT = 'TRAINING_CREDIT',
  USAGE_STORAGE_PACKS = 'USAGE_STORAGE_PACKS',
  USAGE_TIME_PACKS = 'USAGE_TIME_PACKS',
  USER = 'USER',
}

export type Promotion = {
  __typename?: 'Promotion';
  applicationReason?: Maybe<PromotionReason>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
  customisableReasons?: Maybe<Array<Maybe<ReasonCustomisableObj>>>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  cycleIntervalWithEligibleConditions?: Maybe<Array<Maybe<Scalars['String']>>>;
  eligibilityRules?: Maybe<EligibilityRule>;
  id?: Maybe<Scalars['String']>;
  isPromotionCustomisable?: Maybe<Scalars['Boolean']>;
  maxRedemptionsCustomer?: Maybe<Scalars['Int']>;
  maxRedemptionsPromotion?: Maybe<Scalars['Int']>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  promotionDefinition?: Maybe<PromotionDefinition>;
  promotionInstanceId?: Maybe<Scalars['String']>;
  promotionWindow?: Maybe<PromotionWindow>;
  purpose?: Maybe<Purpose>;
  rule?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PromotionApplicationReason = {
  __typename?: 'PromotionApplicationReason';
  id?: Maybe<Scalars['String']>;
};

export type PromotionDefinition = {
  __typename?: 'PromotionDefinition';
  customisedValues?: Maybe<PromotionDefinitionValues>;
  promotionCode?: Maybe<Scalars['String']>;
  promotionId?: Maybe<Scalars['String']>;
};

export type PromotionDefinitionValues = {
  __typename?: 'PromotionDefinitionValues';
  applicationReason?: Maybe<PromotionApplicationReason>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
};

export type PromotionDetail = {
  __typename?: 'PromotionDetail';
  applicationReason?: Maybe<PromotionReason>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
  customisableReasons?: Maybe<Array<Maybe<ReasonCustomisableObj>>>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  cycleIntervalWithEligibleConditions?: Maybe<Array<Maybe<Scalars['String']>>>;
  eligibilityRules?: Maybe<EligibilityRule>;
  id?: Maybe<Scalars['String']>;
  isPromotionCustomisable?: Maybe<Scalars['Boolean']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  maxRedemptionsCustomer?: Maybe<Scalars['Int']>;
  maxRedemptionsPromotion?: Maybe<Scalars['Int']>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  promotionCode?: Maybe<Scalars['String']>;
  promotionCodeType?: Maybe<Scalars['String']>;
  promotionInstanceId?: Maybe<Scalars['String']>;
  promotionWindow?: Maybe<PromotionWindow>;
  purpose?: Maybe<Purpose>;
  rule?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PromotionReason = {
  __typename?: 'PromotionReason';
  customisable?: Maybe<PromotionReasonCustomisable>;
  id?: Maybe<Scalars['String']>;
  readableName?: Maybe<Scalars['String']>;
};

export type PromotionReasonCustomisable = {
  __typename?: 'PromotionReasonCustomisable';
  id?: Maybe<PromotionReasonListObj>;
};

export type PromotionReasonListObj = {
  __typename?: 'PromotionReasonListObj';
  anyOf?: Maybe<Array<Maybe<ReasonCustomisableObj>>>;
  type?: Maybe<Scalars['String']>;
};

export type PromotionWindow = {
  __typename?: 'PromotionWindow';
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type ProratedCharges = {
  __typename?: 'ProratedCharges';
  credits?: Maybe<Scalars['Float']>;
  discountDetails?: Maybe<Array<Maybe<DiscountDetails>>>;
  discountTotal?: Maybe<Scalars['Float']>;
  margins?: Maybe<Array<Maybe<Margins>>>;
  otherDiscount?: Maybe<Scalars['Float']>;
  partnerDiscount?: Maybe<Scalars['Float']>;
  partnerDiscountDetails?: Maybe<PartnerDiscountDetails>;
  partnerPercent?: Maybe<Scalars['Int']>;
  subTotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  taxEstimate?: Maybe<Scalars['Float']>;
  taxItems?: Maybe<Array<Maybe<TaxDetails>>>;
  total?: Maybe<Scalars['Float']>;
  upgradeCreditDetails?: Maybe<Array<Maybe<UpgradeCreditDetails>>>;
  users?: Maybe<Scalars['String']>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  number?: Maybe<Scalars['String']>;
  oneTimeUse?: Maybe<Scalars['Boolean']>;
};

export type Purpose = {
  __typename?: 'Purpose';
  invoiceNote?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type Query = {
  __typename?: 'Query';
  annualPromotions?: Maybe<Array<Maybe<Promotion>>>;
  availableAppsOnSearchBased?: Maybe<PartnerSearchAppsProductsConnection>;
  availablePaidPromotions?: Maybe<Array<Maybe<Promotion>>>;
  availablePartnerPromotions?: Maybe<Array<Maybe<Promotion>>>;
  availablePricingPlansForOffering?: Maybe<Array<Maybe<PricingPlan>>>;
  bulkEditDiscount?: Maybe<Array<Maybe<Promotion>>>;
  ccpQuote: Quote;
  clonedQuote?: Maybe<ClonedQuote>;
  collectionsQuotation?: Maybe<Count>;
  /** Provides insight to if a dependency is currently accessible */
  deepcheck: Array<Maybe<DependencyHealth>>;
  downloadQuote?: Maybe<Quote>;
  isAppCompatibleWithParentProduct?: Maybe<ParentEntitlementConnection>;
  isProductEligibleFor?: Maybe<ProductEligibility>;
  jiraProductsUnderACloudSite?: Maybe<Array<Maybe<ExistingJiraProduct>>>;
  multiInstanceCatalog?: Maybe<ProductConnection>;
  nativeCatalog?: Maybe<ProductConnection>;
  nativeCatalogForCollection?: Maybe<ProductConnection>;
  nativeCatalogForQuote?: Maybe<ProductConnection>;
  nativeCatalogItem: Product;
  nativeCatalogItems?: Maybe<ProductConnection>;
  nonJiraProductsUnderACloudSite?: Maybe<Array<Maybe<ExistingNonJiraProduct>>>;
  opportunityById?: Maybe<OpportunitySearchDetails>;
  partnerNativeCatalog?: Maybe<CatalogueProductConnection>;
  partnerNativeCatalogItem?: Maybe<CatalogueProduct>;
  pricingChangeHistory?: Maybe<PricingChangeHistory>;
  pricingPlans?: Maybe<PricingPlanCatalogue>;
  products?: Maybe<ProductConnection>;
  productsUnderPPCCloudSite?: Maybe<Array<Maybe<ExistingProduct>>>;
  quote: Quote;
  quoteRevisions?: Maybe<QuoteRevisionConnection>;
  quoteV2: Quote;
  quotes?: Maybe<QuoteConnection>;
  searchApps?: Maybe<SearchAppsProductsConnection>;
  searchBasedProducts?: Maybe<SearchAppsProductsConnection>;
  searchProducts: ProductConnection;
  searchProductsInCatalogue: CatalogueProductConnection;
  searchQuote?: Maybe<QuoteConnection>;
  searchQuoteBDM?: Maybe<QuoteConnection>;
  searchQuoteUsingQuoteList?: Maybe<QuoteConnection>;
  searchQuoteV2?: Maybe<QuoteConnection>;
  shareablePdfLink?: Maybe<Scalars['String']>;
  /** Determines if the graph is currently running */
  up: Scalars['Boolean'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAnnualPromotionsArgs = {
  chargeQuantities?: InputMaybe<Array<InputMaybe<ChargeQuantityInput>>>;
  id?: InputMaybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAvailableAppsOnSearchBasedArgs = {
  fetchPartnerPromotionStatus?: InputMaybe<Scalars['Boolean']>;
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageParams?: InputMaybe<ProductPageParams>;
  searchText?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAvailablePaidPromotionsArgs = {
  chargeQuantities?: InputMaybe<Array<InputMaybe<ChargeQuantityInput>>>;
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  id?: InputMaybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAvailablePartnerPromotionsArgs = {
  billingFrequency?: InputMaybe<Scalars['String']>;
  discountTier?: InputMaybe<Scalars['String']>;
  intendedBillingPeriodState?: InputMaybe<Scalars['String']>;
  isAppEntitlement?: InputMaybe<Scalars['Boolean']>;
  offeringLevel?: InputMaybe<Scalars['Int']>;
  offeringLevelPrev?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
  programLevelGlobal?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAvailablePricingPlansForOfferingArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCcpQuoteArgs = {
  id: Scalars['String'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryClonedQuoteArgs = {
  cloneOptions?: InputMaybe<CloneOptions>;
  quoteCloneId?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCollectionsQuotationArgs = {
  exclusions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inclusions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryDownloadQuoteArgs = {
  id?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryIsAppCompatibleWithParentProductArgs = {
  appProductKey?: InputMaybe<Scalars['String']>;
  offeringGroup?: InputMaybe<Scalars['String']>;
  parentProductKey?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryIsProductEligibleForArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryJiraProductsUnderACloudSiteArgs = {
  cloudSiteUrl?: InputMaybe<Scalars['String']>;
  transactionAccountId?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryNativeCatalogArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryNativeCatalogForCollectionArgs = {
  offeringRelationshipType?: InputMaybe<Scalars['String']>;
  productKey?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryNativeCatalogItemArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryNativeCatalogItemsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryNonJiraProductsUnderACloudSiteArgs = {
  cloudSiteUrl?: InputMaybe<Scalars['String']>;
  transactionAccountId?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryOpportunityByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerNativeCatalogArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  id?: InputMaybe<Scalars['ID']>;
  includeExperimentalProducts?: InputMaybe<Scalars['Boolean']>;
  isAddOnsSearchEnabled?: InputMaybe<Scalars['Boolean']>;
  isStatuspageEnabled?: InputMaybe<Scalars['Boolean']>;
  isStrategyCollectionEnabled?: InputMaybe<Scalars['Boolean']>;
  isTeamWorkCollectionEnabled?: InputMaybe<Scalars['Boolean']>;
  offeringGroup?: InputMaybe<Scalars['String']>;
  pageParams?: InputMaybe<ProductPageParams>;
  searchText?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerNativeCatalogItemArgs = {
  id?: InputMaybe<Scalars['ID']>;
  includeExperimentalProducts?: InputMaybe<Scalars['Boolean']>;
  isAddOnsSearchEnabled?: InputMaybe<Scalars['Boolean']>;
  isStatuspageEnabled?: InputMaybe<Scalars['Boolean']>;
  isStrategyCollectionEnabled?: InputMaybe<Scalars['Boolean']>;
  isTeamWorkCollectionEnabled?: InputMaybe<Scalars['Boolean']>;
  offeringGroup?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPricingChangeHistoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
  userTier?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPricingPlansArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  ids: Array<InputMaybe<Scalars['ID']>>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryProductsUnderPpcCloudSiteArgs = {
  cloudSiteUrl?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryQuoteArgs = {
  id?: InputMaybe<Scalars['String']>;
  txaId?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryQuoteRevisionsArgs = {
  quoteNumber?: InputMaybe<Scalars['String']>;
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryQuoteV2Args = {
  id?: InputMaybe<Scalars['String']>;
  txaId?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryQuotesArgs = {
  filterOptions?: InputMaybe<FilterOption>;
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchAppsArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  id?: InputMaybe<Scalars['ID']>;
  pageParams?: InputMaybe<ProductPageParams>;
  searchText?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchBasedProductsArgs = {
  pageParams?: InputMaybe<ProductPageParams>;
  searchText?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchProductsArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  searchText?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchProductsInCatalogueArgs = {
  id?: InputMaybe<Scalars['ID']>;
  includeExperimentalProducts?: InputMaybe<Scalars['Boolean']>;
  offeringGroup?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchQuoteArgs = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  query?: InputMaybe<Scalars['String']>;
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchQuoteBdmArgs = {
  filterOptions?: InputMaybe<FilterOption>;
  query?: InputMaybe<Scalars['String']>;
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchQuoteUsingQuoteListArgs = {
  query?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QuerySearchQuoteV2Args = {
  filterOptions?: InputMaybe<Array<InputMaybe<FilterOption>>>;
  query?: InputMaybe<Scalars['String']>;
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryShareablePdfLinkArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type Quote = {
  __typename?: 'Quote';
  acceptanceKey?: Maybe<Scalars['String']>;
  accountDetails?: Maybe<Array<Maybe<QuoteDetails>>>;
  accountOwnerEmail?: Maybe<Scalars['String']>;
  adminFee?: Maybe<Scalars['String']>;
  adminFeeSubTotal?: Maybe<Scalars['String']>;
  auditNotes?: Maybe<AuditNoteConnection>;
  billTo?: Maybe<BillTo>;
  billToObject?: Maybe<BillTo>;
  billingGroupId?: Maybe<Scalars['String']>;
  cancelledReason?: Maybe<CancelledReason>;
  clonedFrom?: Maybe<Scalars['String']>;
  clonedQuoteNumber?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Author>;
  createdDate?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  discount?: Maybe<Scalars['Float']>;
  downloadPdfLink?: Maybe<Scalars['String']>;
  estimateComputedAt?: Maybe<Scalars['String']>;
  estimateLineItems?: Maybe<Array<Maybe<EstimateLineItemsList>>>;
  estimateRequestedAt?: Maybe<Scalars['String']>;
  expiresAfterDays?: Maybe<Scalars['Float']>;
  expiryDate?: Maybe<Scalars['String']>;
  externalNotes?: Maybe<Array<Maybe<Notes>>>;
  finalizedDate?: Maybe<Scalars['String']>;
  fromQuote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalNotes?: Maybe<Array<Maybe<Notes>>>;
  invoiceGroup?: Maybe<InvoiceGroup>;
  lineItems?: Maybe<Array<Maybe<QuoteLineItem>>>;
  metadata?: Maybe<QuoteMetaData>;
  name?: Maybe<Scalars['String']>;
  opportunityDetail?: Maybe<OpportunityDetails>;
  orderLink?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  pricingCurrency?: Maybe<Currency>;
  quoteAuthor?: Maybe<Scalars['String']>;
  quoteContact?: Maybe<Scalars['String']>;
  quoteNumber?: Maybe<Scalars['String']>;
  reestimate?: Maybe<Scalars['Float']>;
  reestimationInProgress?: Maybe<Scalars['Boolean']>;
  revision?: Maybe<QuoteRevisionConnection>;
  revisionNumber?: Maybe<Scalars['String']>;
  shareablePdfLink?: Maybe<Scalars['String']>;
  shipTo?: Maybe<BillTo>;
  shipToObject?: Maybe<BillTo>;
  staleReason?: Maybe<StaleReason>;
  status?: Maybe<QuoteStatus>;
  statusReason?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['String']>;
  taxEstimate?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Float']>;
  taxType?: Maybe<Scalars['Float']>;
  testParameters?: Maybe<QuoteTestParameters>;
  total?: Maybe<Scalars['String']>;
  transactionAccount?: Maybe<TransactionAccount>;
  transactionAccountId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByObject?: Maybe<Author>;
  updatedDate?: Maybe<Scalars['String']>;
  upgradeCredits?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

export type QuoteAuditNotesArgs = {
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

export type QuoteRevisionArgs = {
  searchOptions?: InputMaybe<ConnectionSearchOptions>;
};

export type QuoteConnection = Connection & {
  __typename?: 'QuoteConnection';
  edges?: Maybe<Array<Maybe<QuoteEdge>>>;
  nodes?: Maybe<Array<Maybe<Quote>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QuoteCustomerContacts = {
  __typename?: 'QuoteCustomerContacts';
  bc_aaids?: Maybe<Scalars['String']>;
};

export type QuoteDetails = {
  __typename?: 'QuoteDetails';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

export type QuoteEdge = Edge & {
  __typename?: 'QuoteEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Quote>;
};

export type QuoteLineItem = {
  __typename?: 'QuoteLineItem';
  accessBillableCount?: Maybe<Scalars['Int']>;
  accountName?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['Int']>;
  adminFee?: Maybe<Scalars['Float']>;
  appsCount?: Maybe<Scalars['Int']>;
  billingAnchor?: Maybe<BillingAnchor>;
  billingAnchorDate?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  cancelledReason?: Maybe<CancelledReason>;
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discountDetails?: Maybe<Array<Maybe<DiscountDetails>>>;
  discountTotal?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['String']>;
  endsAt?: Maybe<EndsAt>;
  enterPriseAggregateCount?: Maybe<Scalars['Int']>;
  enterpriseInstanceHasFamily?: Maybe<Scalars['Boolean']>;
  entitlement?: Maybe<LineItemEntitlement>;
  entitlementId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  entitlementTransactionAccountId?: Maybe<Scalars['String']>;
  entitlementVersion?: Maybe<Scalars['String']>;
  existingEnterpriseInstanceDetails?: Maybe<Array<Maybe<ExistingEnterpriseInstanceDetails>>>;
  frozenTime?: Maybe<Scalars['Int']>;
  isEnterpriceInstanceCountInherited?: Maybe<Scalars['Boolean']>;
  lineItemId: Scalars['ID'];
  lineItemType?: Maybe<Scalars['String']>;
  linkedAccessEntitlementNumber?: Maybe<Scalars['String']>;
  linkedEnterprise?: Maybe<LinkedEnterprise>;
  linkedOrgName?: Maybe<Scalars['String']>;
  linkedRovoEntitlementNumber?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  marginTotal?: Maybe<Scalars['Float']>;
  margins?: Maybe<Array<Maybe<Margins>>>;
  maxUserCount?: Maybe<Scalars['Int']>;
  metadata?: Maybe<QuoteLineItemMetaData>;
  offering?: Maybe<LineItemOffering>;
  offeringKey?: Maybe<Scalars['String']>;
  offerings?: Maybe<Array<Maybe<LineItemOffering>>>;
  orgId?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  preBillingConfiguration?: Maybe<PreBillingConfiguration>;
  pricingCurrency?: Maybe<Currency>;
  pricingPlan?: Maybe<LineItemPricingPlan>;
  pricingPlanDetails?: Maybe<LineItemPricingPlan>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productNote?: Maybe<ProductNote>;
  promotionDetails?: Maybe<Array<Maybe<PromotionDetail>>>;
  promotionStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  proratedCharges?: Maybe<ProratedCharges>;
  provisionedResourceType?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  relatesFromEntitlements?: Maybe<Array<Maybe<LineItemRelation>>>;
  relatesToEntitlements?: Maybe<Array<Maybe<LineItemRelation>>>;
  renewalDate?: Maybe<Scalars['String']>;
  renewalDateTimestamp?: Maybe<Scalars['Float']>;
  staleReason?: Maybe<StaleReason>;
  startDate?: Maybe<Scalars['String']>;
  startsAt?: Maybe<StartsAt>;
  status?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['String']>;
  taxEstimate?: Maybe<Scalars['Float']>;
  taxItems?: Maybe<Array<Maybe<TaxDetails>>>;
  taxRate?: Maybe<Scalars['Float']>;
  termType?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['Float']>;
  unitLabel?: Maybe<Scalars['String']>;
  upgradeCreditDetails?: Maybe<Array<Maybe<UpgradeCreditDetails>>>;
  upgradeCredits?: Maybe<Scalars['Float']>;
  userTierLabel?: Maybe<Scalars['String']>;
};

export type QuoteLineItemConnection = Connection & {
  __typename?: 'QuoteLineItemConnection';
  edges?: Maybe<Array<Maybe<QuoteLineItemEdge>>>;
  nodes?: Maybe<Array<Maybe<QuoteLineItem>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QuoteLineItemEdge = Edge & {
  __typename?: 'QuoteLineItemEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<QuoteLineItem>;
};

export type QuoteLineItemMetaData = {
  __typename?: 'QuoteLineItemMetaData';
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  dunning?: Maybe<Scalars['String']>;
  invoiceWithCredits?: Maybe<Scalars['String']>;
  legacyInvoiceId?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QuoteMetaData = {
  __typename?: 'QuoteMetaData';
  contractId?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
  ecc_aaids?: Maybe<Scalars['String']>;
  quoteContact?: Maybe<Scalars['String']>;
};

export type QuoteRevision = {
  __typename?: 'QuoteRevision';
  createdDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  quoteAuthor?: Maybe<Scalars['String']>;
  quoteNumber?: Maybe<Scalars['String']>;
  revisionNumber?: Maybe<Scalars['String']>;
};

export type QuoteRevisionConnection = Connection & {
  __typename?: 'QuoteRevisionConnection';
  edges?: Maybe<Array<Maybe<QuoteRevisionEdge>>>;
  nodes?: Maybe<Array<Maybe<QuoteRevision>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QuoteRevisionEdge = Edge & {
  __typename?: 'QuoteRevisionEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<QuoteRevision>;
};

export enum QuoteStatus {
  ACCEPTANCE_IN_PROGRESS = 'ACCEPTANCE_IN_PROGRESS',
  ACCEPTED = 'ACCEPTED',
  CANCELLATION_IN_PROGRESS = 'CANCELLATION_IN_PROGRESS',
  CANCELLED = 'CANCELLED',
  CLONING_IN_PROGRESS = 'CLONING_IN_PROGRESS',
  CREATION_IN_PROGRESS = 'CREATION_IN_PROGRESS',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  FINALIZATION_IN_PROGRESS = 'FINALIZATION_IN_PROGRESS',
  OPEN = 'OPEN',
  PROCESSED = 'PROCESSED',
  QUOTED = 'QUOTED',
  REVIEW_REQUIRED = 'REVIEW_REQUIRED',
  REVISION_IN_PROGRESS = 'REVISION_IN_PROGRESS',
  STALE = 'STALE',
  SUPERSEDED = 'SUPERSEDED',
  UPDATE_IN_PROGRESS = 'UPDATE_IN_PROGRESS',
  UPDATION_IN_PROGRESS = 'UPDATION_IN_PROGRESS',
  VALIDATION_IN_PROGRESS = 'VALIDATION_IN_PROGRESS',
}

export type QuoteTestParameters = {
  __typename?: 'QuoteTestParameters';
  testClockId?: Maybe<Scalars['String']>;
};

export type QuoteWhereFilter = {
  billingGroupId?: InputMaybe<Scalars['String']>;
  ccpEntitlementId?: InputMaybe<Scalars['String']>;
  cloudSiteId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  quoteAuthor?: InputMaybe<Scalars['String']>;
  quoteContact?: InputMaybe<Scalars['String']>;
  quoteNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transactionAccountId?: InputMaybe<Scalars['String']>;
};

export type ReasonCustomisableObj = {
  __typename?: 'ReasonCustomisableObj';
  id?: Maybe<Scalars['String']>;
  readableName?: Maybe<Scalars['String']>;
};

export type RelatesFromEntitlements = {
  __typename?: 'RelatesFromEntitlements';
  entitlementId?: Maybe<Scalars['String']>;
  relationshipId?: Maybe<Scalars['String']>;
  relationshipType?: Maybe<Scalars['String']>;
};

export type RelationshipGroup = {
  __typename?: 'RelationshipGroup';
  cardinality?: Maybe<Cardinality>;
  group?: Maybe<Scalars['String']>;
  offeringKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RelationshipNode = {
  __typename?: 'RelationshipNode';
  cardinality?: Maybe<Cardinality>;
  groups?: Maybe<Array<Maybe<RelationshipGroup>>>;
  selector?: Maybe<Scalars['String']>;
};

export type RelationshipRequirement = {
  __typename?: 'RelationshipRequirement';
  level?: Maybe<Scalars['String']>;
  side?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum SalesMotionTypes {
  AMEND = 'AMEND',
  NEW = 'NEW',
  RENEW = 'RENEW',
}

export type ScheduledChanges = {
  __typename?: 'ScheduledChanges';
  nextChangeTimestamp?: Maybe<Scalars['Float']>;
  pauseBilling?: Maybe<PauseBilling>;
  pricingPlan?: Maybe<LineItemPricingPlan>;
  startTimestamp?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriptionScheduleAction?: Maybe<SubscriptionScheduleAction>;
};

export type SearchAppsProducts = {
  __typename?: 'SearchAppsProducts';
  appName?: Maybe<Scalars['String']>;
  chargeElement?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAddOn?: Maybe<Scalars['Boolean']>;
  offeringName?: Maybe<Scalars['String']>;
  pricingPlanKey?: Maybe<Scalars['String']>;
  pricingPlanLabel?: Maybe<Scalars['String']>;
  pricingType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SearchAppsProductsConnection = Connection & {
  __typename?: 'SearchAppsProductsConnection';
  nodes?: Maybe<Array<Maybe<SearchAppsProducts>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Direction to sort returned connection */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** ElasticSearch Script for finely tuned sorts (used with Hydra) */
export type SortScript = {
  order?: InputMaybe<Scalars['String']>;
  returnType?: InputMaybe<Scalars['String']>;
  script?: InputMaybe<Scalars['String']>;
};

/** Available sort options; defaults to Hydra terminology */
export type SortType = {
  /** Fields to sort, must be equal length to sortFieldsDirections */
  sortFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Direction to sort, must be equal length to sortFields */
  sortFieldsDirections?: InputMaybe<Array<InputMaybe<SortDirection>>>;
  sortScript?: InputMaybe<Array<InputMaybe<SortScript>>>;
};

export type StaleReason = {
  __typename?: 'StaleReason';
  code?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  lastUpdatedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Scalars['String']>;
};

export type StartsAt = {
  __typename?: 'StartsAt';
  timestamp?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum Status {
  ACTIVE = 'ACTIVE',
  AT_NOTICE = 'AT_NOTICE',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  GRANDFATHERED = 'GRANDFATHERED',
}

export enum SubscriptionScheduleAction {
  CANCEL = 'CANCEL',
  TRANSFER = 'TRANSFER',
  UPDATE = 'UPDATE',
  UPDATE_CANCEL = 'UPDATE_CANCEL',
  UPDATE_TRANSFER = 'UPDATE_TRANSFER',
}

export type TaxDetails = {
  __typename?: 'TaxDetails';
  tax?: Maybe<Scalars['Float']>;
  taxAmountLabel?: Maybe<Scalars['String']>;
  taxPercent?: Maybe<Scalars['Float']>;
};

export type TestParameter = {
  __typename?: 'TestParameter';
  testClockId?: Maybe<Scalars['String']>;
};

export type ToOfferingDetails = {
  __typename?: 'ToOfferingDetails';
  id?: Maybe<Scalars['String']>;
};

export type TransactionAccount = {
  __typename?: 'TransactionAccount';
  id: Scalars['ID'];
  isPartner?: Maybe<Scalars['Boolean']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  type?: Maybe<TransactionAccountStatusType>;
};

export enum TransactionAccountStatusType {
  DIRECT = 'DIRECT',
  PARTNER = 'PARTNER',
  UNAFFILIATED_RESELLER = 'UNAFFILIATED_RESELLER',
}

export enum UnitLabel {
  AGENT = 'AGENT',
  MACHINE = 'MACHINE',
  MANAGER = 'MANAGER',
  NONE = 'NONE',
  REMOTE_AGENT = 'REMOTE_AGENT',
  TRAINING_CREDIT = 'TRAINING_CREDIT',
  USAGE_STORAGE_PACKS = 'USAGE_STORAGE_PACKS',
  USAGE_TIME_PACKS = 'USAGE_TIME_PACKS',
  USER = 'USER',
}

export type UpgradeCreditDetails = {
  __typename?: 'UpgradeCreditDetails';
  endsAt?: Maybe<Scalars['Float']>;
  externalInvoiceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoiceRequestItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  margins?: Maybe<Array<Maybe<Margins>>>;
  startsAt?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  taxItems?: Maybe<Array<Maybe<TaxDetails>>>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

export type UpgradeTrialDetails = {
  __typename?: 'UpgradeTrialDetails';
  offeringId?: Maybe<Scalars['String']>;
};

export type NextId = {
  __typename?: 'nextId';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FetchNativeCatalogProductDetailsQueryVariables = Exact<{
  pageParams?: Maybe<ProductPageParams>;
  searchText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  includeExperimentalProducts?: Maybe<Scalars['Boolean']>;
  isAddOnsSearchEnabled?: Maybe<Scalars['Boolean']>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  isStatuspageEnabled?: Maybe<Scalars['Boolean']>;
  isTeamWorkCollectionEnabled?: Maybe<Scalars['Boolean']>;
  isStrategyCollectionEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchNativeCatalogProductDetailsQuery = { __typename?: 'Query' } & {
  nativeCatalog?: Maybe<
    { __typename?: 'CatalogueProductConnection' } & Pick<CatalogueProductConnection, 'totalCount'> & {
        nodes: Array<
          Maybe<
            { __typename?: 'CatalogueProduct' } & Pick<
              CatalogueProduct,
              | 'id'
              | 'name'
              | 'vendorName'
              | 'productFamily'
              | 'productType'
              | 'baseProduct'
              | 'isApp'
              | 'isEnabledForOrder'
              | 'logoId'
              | 'url'
              | 'currency'
              | 'hasOptedInForPartnerPromotion'
            >
          >
        >;
      }
  >;
};

export type FetchNativeProductCatalogueWithOfferingAndPricingPlansQueryVariables = Exact<{
  pageParams?: Maybe<ProductPageParams>;
  searchText?: Maybe<Scalars['String']>;
  pricingPlanFilterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  includeExperimentalProducts?: Maybe<Scalars['Boolean']>;
  isAddOnsSearchEnabled?: Maybe<Scalars['Boolean']>;
  isStatuspageEnabled?: Maybe<Scalars['Boolean']>;
  isTeamWorkCollectionEnabled?: Maybe<Scalars['Boolean']>;
  isStrategyCollectionEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchNativeProductCatalogueWithOfferingAndPricingPlansQuery = { __typename?: 'Query' } & {
  nativeCatalog?: Maybe<
    { __typename?: 'CatalogueProductConnection' } & Pick<CatalogueProductConnection, 'totalCount'> & {
        nodes: Array<
          Maybe<
            { __typename?: 'CatalogueProduct' } & Pick<
              CatalogueProduct,
              | 'id'
              | 'name'
              | 'productFamily'
              | 'productType'
              | 'updatedDate'
              | 'baseProduct'
              | 'isApp'
              | 'isProduct'
              | 'isEnabledForOrder'
              | 'logoId'
              | 'url'
              | 'currency'
              | 'hasOptedInForPartnerPromotion'
              | 'vendorName'
            > & {
                addonParentProducts?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'CatalogueAddonParentProduct' } & Pick<CatalogueAddonParentProduct, 'parentName'>
                    >
                  >
                >;
                plans?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'CatalogueProductPlans' } & Pick<
                        CatalogueProductPlans,
                        'id' | 'name' | 'pricingPlanType' | 'listPrice' | 'priceUpdated' | 'periodUnit'
                      >
                    >
                  >
                >;
                offering?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'ProductOffering' } & Pick<
                        ProductOffering,
                        | 'id'
                        | 'offeringName'
                        | 'pricingType'
                        | 'level'
                        | 'trialLengthInDays'
                        | 'offeringGroup'
                        | 'availableProducts'
                      > & {
                          relationshipRequirements?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'RelationshipRequirement' } & Pick<
                                  RelationshipRequirement,
                                  'level' | 'side' | 'type'
                                >
                              >
                            >
                          >;
                          availableAddOns?: Maybe<
                            Array<Maybe<{ __typename?: 'ProductAddOn' } & Pick<ProductAddOn, 'offeringId' | 'name'>>>
                          >;
                          chargeElements?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'ChargeElement' } & Pick<ChargeElement, 'type'> & {
                                    data: { __typename?: 'ChargeElementData' } & Pick<ChargeElementData, 'ceiling'>;
                                  }
                              >
                            >
                          >;
                          availablePricingPlans?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'PricingPlan' } & Pick<
                                  PricingPlan,
                                  | 'type'
                                  | 'billingFrequency'
                                  | 'updatedAt'
                                  | 'id'
                                  | 'currency'
                                  | 'pricingPlanType'
                                  | 'status'
                                  | 'description'
                                > & {
                                    tiers?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: 'PricePlanTiers' } & Pick<
                                            PricePlanTiers,
                                            'floor' | 'ceiling' | 'amount' | 'unitAmount' | 'flatAmount'
                                          >
                                        >
                                      >
                                    >;
                                  }
                              >
                            >
                          >;
                        }
                    >
                  >
                >;
              }
          >
        >;
        pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
      }
  >;
};

export type FetchProductsUnderPpCloudSiteQueryVariables = Exact<{
  cloudSiteUrl?: Maybe<Scalars['String']>;
}>;

export type FetchProductsUnderPpCloudSiteQuery = { __typename?: 'Query' } & {
  productsUnderPPCCloudSite?: Maybe<
    Array<
      Maybe<
        { __typename?: 'ExistingProduct' } & Pick<
          ExistingProduct,
          | 'id'
          | 'transactionAccountId'
          | 'productCatalogId'
          | 'cloudSiteId'
          | 'cloudSiteHostname'
          | 'invoiceGroupId'
          | 'sourceSystem'
        > & {
            relatesFromEntitlements?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'RelatesFromEntitlements' } & Pick<
                    RelatesFromEntitlements,
                    'entitlementId' | 'relationshipType'
                  >
                >
              >
            >;
          }
      >
    >
  >;
};

export type FetchQuotesOrderDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  txaId?: Maybe<Scalars['String']>;
}>;

export type FetchQuotesOrderDetailsQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & Pick<Quote, 'id'> & {
      lineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'QuoteLineItem' } & Pick<QuoteLineItem, 'lineItemId'> & {
                metadata?: Maybe<
                  { __typename?: 'QuoteLineItemMetaData' } & Pick<QuoteLineItemMetaData, 'legacyInvoiceId'>
                >;
              }
          >
        >
      >;
    };
};

export type FetchQuotesForTransactionAccountQueryVariables = Exact<{
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
  fetchLineItems?: Maybe<Scalars['Boolean']>;
}>;

export type FetchQuotesForTransactionAccountQuery = { __typename?: 'Query' } & {
  quotes?: Maybe<
    { __typename?: 'QuoteConnection' } & Pick<QuoteConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Quote' } & Pick<
                Quote,
                | 'id'
                | 'status'
                | 'quoteNumber'
                | 'name'
                | 'quoteContact'
                | 'quoteAuthor'
                | 'billingGroupId'
                | 'revisionNumber'
                | 'updatedBy'
                | 'createdDate'
                | 'expiryDate'
                | 'updatedDate'
                | 'estimateComputedAt'
                | 'total'
                | 'currency'
                | 'poNumber'
              > & {
                  billToObject?: Maybe<{ __typename?: 'BillTo' } & Pick<BillTo, 'companyName'>>;
                  shipToObject?: Maybe<
                    { __typename?: 'BillTo' } & Pick<
                      BillTo,
                      | 'id'
                      | 'displayName'
                      | 'addressLine1'
                      | 'addressLine2'
                      | 'city'
                      | 'country'
                      | 'postalCode'
                      | 'state'
                    >
                  >;
                  createdBy?: Maybe<{ __typename?: 'Author' } & Pick<Author, 'subject'>>;
                  updatedByObject?: Maybe<{ __typename?: 'Author' } & Pick<Author, 'subject'>>;
                  metadata?: Maybe<
                    { __typename?: 'QuoteMetaData' } & Pick<QuoteMetaData, 'quoteContact' | 'ecc_aaids'>
                  >;
                  staleReason?: Maybe<
                    { __typename?: 'StaleReason' } & Pick<StaleReason, 'code' | 'name' | 'lastUpdatedDate'>
                  >;
                  estimateLineItems?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'EstimateLineItemsList' } & {
                          discountDetails?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'DiscountDetails' } & Pick<
                                  DiscountDetails,
                                  'promotionId' | 'discountAmount' | 'percentOff' | 'reasonCode' | 'discountType'
                                >
                              >
                            >
                          >;
                          margins?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'Margins' } & Pick<
                                  Margins,
                                  'promotionId' | 'amount' | 'percent' | 'reasonCode' | 'type' | 'promoCode'
                                >
                              >
                            >
                          >;
                        }
                      >
                    >
                  >;
                  lineItems?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'QuoteLineItem' } & {
                          offerings?: Maybe<
                            Array<Maybe<{ __typename?: 'LineItemOffering' } & Pick<LineItemOffering, 'pricingType'>>>
                          >;
                        }
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchProductIdOfferingIdsQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  offeringFilter?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  isAddOnsSearchEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchProductIdOfferingIdsQuery = { __typename?: 'Query' } & {
  nativeCatalogItem?: Maybe<
    { __typename?: 'CatalogueProduct' } & Pick<CatalogueProduct, 'id'> & {
        offering?: Maybe<
          Array<
            Maybe<
              { __typename?: 'ProductOffering' } & Pick<
                ProductOffering,
                'id' | 'offeringName' | 'pricingType' | 'trialLengthInDays' | 'offeringGroup'
              > & {
                  availablePricingPlans?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'PricingPlan' } & Pick<
                          PricingPlan,
                          | 'type'
                          | 'billingFrequency'
                          | 'updatedAt'
                          | 'id'
                          | 'currency'
                          | 'pricingPlanType'
                          | 'status'
                          | 'description'
                        >
                      >
                    >
                  >;
                  relationshipRequirements?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'RelationshipRequirement' } & Pick<
                          RelationshipRequirement,
                          'level' | 'side' | 'type'
                        >
                      >
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FetchNativeProductCollectionForCatalogueQueryVariables = Exact<{
  productKey?: Maybe<Scalars['String']>;
  offeringRelationshipType?: Maybe<Scalars['String']>;
}>;

export type FetchNativeProductCollectionForCatalogueQuery = { __typename?: 'Query' } & {
  nativeCatalogForCollection?: Maybe<
    { __typename?: 'ProductConnection' } & {
      nodes: Array<
        Maybe<
          { __typename?: 'Product' } & {
            productOfferingsForCollection?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Offering' } & Pick<Offering, 'id'> & {
                      product?: Maybe<
                        { __typename?: 'OfferingProductDetails' } & Pick<OfferingProductDetails, 'id' | 'name'>
                      >;
                    }
                >
              >
            >;
          }
        >
      >;
    }
  >;
};

export type FetchNativeProductCollectionForChangeSubscriptionQueryVariables = Exact<{
  productKey?: Maybe<Scalars['String']>;
  offeringRelationshipType?: Maybe<Scalars['String']>;
}>;

export type FetchNativeProductCollectionForChangeSubscriptionQuery = { __typename?: 'Query' } & {
  nativeCatalogForCollection?: Maybe<
    { __typename?: 'ProductConnection' } & {
      nodes: Array<
        Maybe<
          { __typename?: 'Product' } & {
            offeringCollections?: Maybe<
              Array<Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'toOfferingIds'>>>
            >;
            productOfferingsForCollection?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Offering' } & Pick<Offering, 'id' | 'offeringName'> & {
                      product?: Maybe<
                        { __typename?: 'OfferingProductDetails' } & Pick<OfferingProductDetails, 'id' | 'name'>
                      >;
                    }
                >
              >
            >;
          }
        >
      >;
    }
  >;
};

export type FetchDueQuotesForHomePageInPpcQueryVariables = Exact<{
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
}>;

export type FetchDueQuotesForHomePageInPpcQuery = { __typename?: 'Query' } & {
  quotes?: Maybe<
    { __typename?: 'QuoteConnection' } & Pick<QuoteConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Quote' } & Pick<
                Quote,
                | 'id'
                | 'transactionAccountId'
                | 'quoteNumber'
                | 'status'
                | 'expiryDate'
                | 'createdDate'
                | 'currency'
                | 'total'
              > & { shipToObject?: Maybe<{ __typename?: 'BillTo' } & Pick<BillTo, 'displayName'>> }
            >
          >
        >;
      }
  >;
};

export type FetchRecentlyCreatedQuotesForHomePageInPpcQueryVariables = Exact<{
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
}>;

export type FetchRecentlyCreatedQuotesForHomePageInPpcQuery = { __typename?: 'Query' } & {
  quotes?: Maybe<
    { __typename?: 'QuoteConnection' } & Pick<QuoteConnection, 'totalCount'> & {
        nodes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Quote' } & Pick<
                Quote,
                | 'id'
                | 'transactionAccountId'
                | 'quoteNumber'
                | 'status'
                | 'createdDate'
                | 'expiryDate'
                | 'currency'
                | 'total'
              > & { shipToObject?: Maybe<{ __typename?: 'BillTo' } & Pick<BillTo, 'displayName'>> }
            >
          >
        >;
      }
  >;
};

export type FetchQuotesByOrderLineIdQueryVariables = Exact<{
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<FilterOption>;
}>;

export type FetchQuotesByOrderLineIdQuery = { __typename?: 'Query' } & {
  quotes?: Maybe<
    { __typename?: 'QuoteConnection' } & Pick<QuoteConnection, 'totalCount'> & {
        nodes?: Maybe<Array<Maybe<{ __typename?: 'Quote' } & Pick<Quote, 'id' | 'quoteNumber'>>>>;
      }
  >;
};

export type QuoteStatusQueryQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  txaId?: Maybe<Scalars['String']>;
}>;

export type QuoteStatusQueryQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & Pick<Quote, 'status'>;
};

export type BlendedComputationDetailsFragment = { __typename?: 'Margins' } & Pick<Margins, 'blended'> & {
    blendedComputation?: Maybe<
      { __typename?: 'BlendedComputation' } & Pick<
        BlendedComputation,
        | 'newGlp'
        | 'previousGlp'
        | 'upsellPercentage'
        | 'renewPercentage'
        | 'upsellValue'
        | 'renewalValue'
        | 'upsellMargin'
        | 'renewalMargin'
        | 'blendedMargin'
      >
    >;
  };

export type QuoteFragmentFragment = { __typename?: 'Quote' } & MakeOptional<
  Pick<
    Quote,
    | 'reestimationInProgress'
    | 'id'
    | 'quoteNumber'
    | 'name'
    | 'status'
    | 'billingGroupId'
    | 'version'
    | 'quoteContact'
    | 'contractType'
    | 'transactionAccountId'
    | 'pricingCurrency'
    | 'expiresAfterDays'
    | 'adminFee'
    | 'adminFeeSubTotal'
    | 'discount'
    | 'subTotal'
    | 'total'
    | 'taxEstimate'
    | 'quoteAuthor'
    | 'revisionNumber'
    | 'currency'
    | 'expiryDate'
    | 'createdDate'
    | 'updatedDate'
    | 'estimateComputedAt'
    | 'updatedBy'
    | 'upgradeCredits'
  >,
  'pricingCurrency'
> & {
    invoiceGroup?: Maybe<
      { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'name' | 'pricingEligibility'> & {
          purchaseOrder?: Maybe<{ __typename?: 'PurchaseOrder' } & Pick<PurchaseOrder, 'number'>>;
        }
    >;
    externalNotes?: Maybe<Array<Maybe<{ __typename?: 'Notes' } & Pick<Notes, 'note'>>>>;
    billTo?: Maybe<
      { __typename?: 'BillTo' } & Pick<
        BillTo,
        'companyName' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postalCode'
      > & {
          taxIds?: Maybe<
            Array<
              Maybe<
                { __typename?: 'BillToTaxItems' } & Pick<
                  BillToTaxItems,
                  'label' | 'taxIdLabel' | 'taxExempt' | 'taxIdDescription' | 'id'
                >
              >
            >
          >;
        }
    >;
    shipTo?: Maybe<
      { __typename?: 'BillTo' } & Pick<
        BillTo,
        'companyName' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postalCode'
      > & {
          taxIds?: Maybe<
            Array<
              Maybe<
                { __typename?: 'BillToTaxItems' } & Pick<
                  BillToTaxItems,
                  'label' | 'taxIdLabel' | 'taxExempt' | 'taxIdDescription' | 'id'
                >
              >
            >
          >;
        }
    >;
    revision?: Maybe<{ __typename?: 'QuoteRevisionConnection' } & Pick<QuoteRevisionConnection, 'totalCount'>>;
    staleReason?: Maybe<
      { __typename?: 'StaleReason' } & Pick<
        StaleReason,
        'code' | 'name' | 'lastUpdatedAt' | 'expiresAt' | 'orderId' | 'orderItemId'
      >
    >;
    cancelledReason?: Maybe<
      { __typename?: 'CancelledReason' } & Pick<
        CancelledReason,
        'code' | 'name' | 'lastUpdatedAt' | 'orderId' | 'orderItemId'
      >
    >;
    lineItems?: Maybe<
      Array<
        Maybe<
          { __typename?: 'QuoteLineItem' } & Pick<
            QuoteLineItem,
            | 'status'
            | 'lineItemId'
            | 'accountName'
            | 'description'
            | 'orgId'
            | 'orgName'
            | 'linkedOrgName'
            | 'marginTotal'
            | 'billingAnchorDate'
            | 'cloudSiteId'
            | 'cloudSiteHostname'
            | 'entitlementId'
            | 'entitlementNumber'
            | 'entitlementTransactionAccountId'
            | 'productKey'
            | 'logoId'
            | 'offeringKey'
            | 'pricingPlanId'
            | 'pricingCurrency'
            | 'entitlementVersion'
            | 'lineItemType'
            | 'quantity'
            | 'startDate'
            | 'endDate'
            | 'total'
            | 'subTotal'
            | 'taxEstimate'
            | 'billingFrequency'
            | 'userTierLabel'
            | 'promotionStatus'
            | 'discountTotal'
            | 'upgradeCredits'
            | 'adminFee'
          > & {
              metadata?: Maybe<
                { __typename?: 'QuoteLineItemMetaData' } & Pick<QuoteLineItemMetaData, 'legacyInvoiceId'>
              >;
              billingAnchor?: Maybe<{ __typename?: 'BillingAnchor' } & Pick<BillingAnchor, 'type' | 'timestamp'>>;
              startsAt?: Maybe<{ __typename?: 'StartsAt' } & Pick<StartsAt, 'type' | 'timestamp'>>;
              margins?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Margins' } & Pick<
                      Margins,
                      'amount' | 'type' | 'percent' | 'startsAt' | 'endsAt' | 'total' | 'taxAmount'
                    > &
                      BlendedComputationDetailsFragment
                  >
                >
              >;
              endsAt?: Maybe<
                { __typename?: 'EndsAt' } & Pick<EndsAt, 'type' | 'timestamp'> & {
                    duration?: Maybe<{ __typename?: 'Duration' } & Pick<Duration, 'interval' | 'intervalCount'>>;
                  }
              >;
              entitlement?: Maybe<
                { __typename?: 'LineItemEntitlement' } & Pick<LineItemEntitlement, 'billingStatus'> & {
                    pauseBilling?: Maybe<
                      { __typename?: 'PauseBilling' } & Pick<PauseBilling, 'startTimestamp' | 'endTimestamp'>
                    >;
                    scheduledChanges?: Maybe<
                      { __typename?: 'ScheduledChanges' } & {
                        pauseBilling?: Maybe<
                          { __typename?: 'PauseBilling' } & Pick<PauseBilling, 'startTimestamp' | 'endTimestamp'>
                        >;
                      }
                    >;
                    offering?: Maybe<
                      { __typename?: 'Offering' } & Pick<Offering, 'id' | 'name' | 'description' | 'productKey'> & {
                          relationshipRequirements?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'RelationshipRequirement' } & Pick<
                                  RelationshipRequirement,
                                  'side' | 'level' | 'type'
                                >
                              >
                            >
                          >;
                          product?: Maybe<
                            { __typename?: 'OfferingProductDetails' } & Pick<OfferingProductDetails, 'id' | 'name'>
                          >;
                        }
                    >;
                    relatesToEntitlements?: Maybe<
                      Array<Maybe<{ __typename?: 'LineItemRelation' } & Pick<LineItemRelation, 'relationshipType'>>>
                    >;
                  }
              >;
              proratedCharges?: Maybe<
                { __typename?: 'ProratedCharges' } & Pick<
                  ProratedCharges,
                  'subTotal' | 'credits' | 'discountTotal' | 'total' | 'users' | 'otherDiscount' | 'taxEstimate'
                > & {
                    partnerDiscountDetails?: Maybe<
                      { __typename?: 'PartnerDiscountDetails' } & Pick<
                        PartnerDiscountDetails,
                        'totalPartnerDiscount'
                      > & {
                          partnerDiscounts?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'DiscountDetails' } & Pick<
                                  DiscountDetails,
                                  'promotionId' | 'discountAmount' | 'percentOff' | 'reasonCode' | 'discountType'
                                > & { period?: Maybe<{ __typename?: 'Period' } & Pick<Period, 'startsAt' | 'endsAt'>> }
                              >
                            >
                          >;
                        }
                    >;
                    taxItems?: Maybe<
                      Array<
                        Maybe<{ __typename?: 'TaxDetails' } & Pick<TaxDetails, 'tax' | 'taxAmountLabel' | 'taxPercent'>>
                      >
                    >;
                  }
              >;
              preBillingConfiguration?: Maybe<
                { __typename?: 'PreBillingConfiguration' } & {
                  billFrom?: Maybe<{ __typename?: 'PreBillFrom' } & Pick<PreBillFrom, 'type' | 'timestamp'>>;
                  billTo?: Maybe<
                    { __typename?: 'PreBillTo' } & Pick<PreBillTo, 'type' | 'timestamp'> & {
                        duration?: Maybe<{ __typename?: 'Duration' } & Pick<Duration, 'interval' | 'intervalCount'>>;
                      }
                  >;
                }
              >;
              relatesFromEntitlements?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'LineItemRelation' } & Pick<
                      LineItemRelation,
                      'relationshipType' | 'lineItemId' | 'referenceType' | 'entitlementId'
                    >
                  >
                >
              >;
              pricingPlan?: Maybe<
                { __typename?: 'LineItemPricingPlan' } & Pick<
                  LineItemPricingPlan,
                  'pricingPlanType' | 'billingFrequency'
                >
              >;
              chargeQuantities?: Maybe<
                Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'quantity' | 'chargeElement'>>>
              >;
              offerings?: Maybe<
                Array<
                  Maybe<{ __typename?: 'LineItemOffering' } & Pick<LineItemOffering, 'offeringName' | 'pricingType'>>
                >
              >;
              offering?: Maybe<
                { __typename?: 'LineItemOffering' } & {
                  relationshipRequirements?: Maybe<
                    Array<
                      Maybe<{ __typename?: 'RelationshipRequirement' } & Pick<RelationshipRequirement, 'side' | 'type'>>
                    >
                  >;
                }
              >;
              promotions?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Promotion' } & Pick<Promotion, 'promotionInstanceId' | 'type'> & {
                        promotionDefinition?: Maybe<
                          { __typename?: 'PromotionDefinition' } & Pick<
                            PromotionDefinition,
                            'promotionId' | 'promotionCode'
                          > & {
                              customisedValues?: Maybe<
                                { __typename?: 'PromotionDefinitionValues' } & {
                                  benefits?: Maybe<
                                    Array<
                                      Maybe<
                                        { __typename?: 'Benefit' } & Pick<
                                          Benefit,
                                          'duration' | 'value' | 'iterations'
                                        > & {
                                            values?: Maybe<
                                              Array<
                                                Maybe<
                                                  { __typename?: 'BenefitsValueObj' } & Pick<
                                                    BenefitsValueObj,
                                                    'appliedOn' | 'value'
                                                  >
                                                >
                                              >
                                            >;
                                          }
                                      >
                                    >
                                  >;
                                  applicationReason?: Maybe<
                                    { __typename?: 'PromotionApplicationReason' } & Pick<
                                      PromotionApplicationReason,
                                      'id'
                                    >
                                  >;
                                }
                              >;
                            }
                        >;
                      }
                  >
                >
              >;
              promotionDetails?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'PromotionDetail' } & Pick<
                      PromotionDetail,
                      | 'id'
                      | 'promotionCode'
                      | 'title'
                      | 'type'
                      | 'promotionInstanceId'
                      | 'status'
                      | 'cycleInterval'
                      | 'pricingType'
                      | 'cycleIntervalWithEligibleConditions'
                      | 'isPromotionCustomisable'
                    > & {
                        benefits?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Benefit' } & Pick<
                                Benefit,
                                | 'benefitType'
                                | 'duration'
                                | 'subBenefitType'
                                | 'iterations'
                                | 'value'
                                | 'scale'
                                | 'type'
                              >
                            >
                          >
                        >;
                        promotionWindow?: Maybe<
                          { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                        >;
                        eligibilityRules?: Maybe<
                          { __typename?: 'EligibilityRule' } & Pick<
                            EligibilityRule,
                            | 'products'
                            | 'cycleInterval'
                            | 'pricingType'
                            | 'partnerType'
                            | 'partnerTier'
                            | 'saleTransitionType'
                            | 'currency'
                          >
                        >;
                        applicationReason?: Maybe<
                          { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                              customisable?: Maybe<
                                { __typename?: 'PromotionReasonCustomisable' } & {
                                  id?: Maybe<
                                    { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                        anyOf?: Maybe<
                                          Array<
                                            Maybe<
                                              { __typename?: 'ReasonCustomisableObj' } & Pick<
                                                ReasonCustomisableObj,
                                                'readableName' | 'id'
                                              >
                                            >
                                          >
                                        >;
                                      }
                                  >;
                                }
                              >;
                            }
                        >;
                        customisableReasons?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'ReasonCustomisableObj' } & Pick<
                                ReasonCustomisableObj,
                                'readableName' | 'id'
                              >
                            >
                          >
                        >;
                      }
                  >
                >
              >;
              discountDetails?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'DiscountDetails' } & Pick<
                      DiscountDetails,
                      'promotionId' | 'discountAmount' | 'percentOff' | 'reasonCode' | 'discountType'
                    >
                  >
                >
              >;
              taxItems?: Maybe<
                Array<Maybe<{ __typename?: 'TaxDetails' } & Pick<TaxDetails, 'tax' | 'taxAmountLabel' | 'taxPercent'>>>
              >;
              upgradeCreditDetails?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'UpgradeCreditDetails' } & Pick<
                      UpgradeCreditDetails,
                      'subTotal' | 'startsAt' | 'endsAt' | 'total' | 'invoiceRequestItemIds'
                    > & {
                        taxItems?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'TaxDetails' } & Pick<TaxDetails, 'tax' | 'taxAmountLabel' | 'taxPercent'>
                            >
                          >
                        >;
                        margins?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Margins' } & Pick<
                                Margins,
                                'promotionId' | 'amount' | 'percent' | 'reasonCode' | 'type'
                              >
                            >
                          >
                        >;
                      }
                  >
                >
              >;
              staleReason?: Maybe<
                { __typename?: 'StaleReason' } & Pick<
                  StaleReason,
                  'code' | 'name' | 'lastUpdatedAt' | 'expiresAt' | 'orderId' | 'orderItemId'
                >
              >;
              cancelledReason?: Maybe<
                { __typename?: 'CancelledReason' } & Pick<
                  CancelledReason,
                  'code' | 'name' | 'lastUpdatedAt' | 'orderId' | 'orderItemId'
                >
              >;
            }
        >
      >
    >;
    metadata?: Maybe<
      { __typename?: 'QuoteMetaData' } & Pick<
        QuoteMetaData,
        'ecc_aaids' | 'quoteContact' | 'contractType' | 'contractId'
      >
    >;
  };

export type FetchQuoteDetailsPpcQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  txaId?: Maybe<Scalars['String']>;
  isBlendedMarginEnabled?: Maybe<Scalars['Boolean']>;
  isProratedChangesEnabled?: Maybe<Scalars['Boolean']>;
  isMultiCurrencyChangesEnabled?: Maybe<Scalars['Boolean']>;
  isFetchingEntitlementEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchQuoteDetailsPpcQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & QuoteFragmentFragment;
};

export type FetchAvailableAppPriceQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  count?: Maybe<Scalars['String']>;
  appFilterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchAvailableAppPriceQuery = { __typename?: 'Query' } & {
  nativeCatalogItem: { __typename?: 'Product' } & Pick<Product, 'id'> & {
      offering?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<Offering, 'id' | 'offeringName'> & {
                availableApps?: Maybe<Array<Maybe<{ __typename?: 'AppOffering' } & Pick<AppOffering, 'id' | 'price'>>>>;
              }
          >
        >
      >;
    };
};

export type FetchAvailableAppsQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchAvailableAppsQuery = { __typename?: 'Query' } & {
  nativeCatalogItem: { __typename?: 'Product' } & Pick<Product, 'id'> & {
      offering?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<Offering, 'id' | 'offeringName'> & {
                availableApps?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'AppOffering' } & Pick<
                        AppOffering,
                        | 'id'
                        | 'name'
                        | 'edition'
                        | 'pricingType'
                        | 'updatedDate'
                        | 'status'
                        | 'offeringName'
                        | 'pricingPlanKey'
                        | 'productKey'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchAvailablePricingPlansQueryVariables = Exact<{
  id: Scalars['ID'];
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  offeringFilter?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
  queryDefaultPricingPlans?: Maybe<Scalars['Boolean']>;
}>;

export type FetchAvailablePricingPlansQuery = { __typename?: 'Query' } & {
  nativeCatalogItem: { __typename?: 'Product' } & Pick<Product, 'id'> & {
      offering?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<Offering, 'id' | 'offeringName'> & {
                availablePricingPlans?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'PricingPlan' } & Pick<
                        PricingPlan,
                        | 'type'
                        | 'billingFrequency'
                        | 'updatedAt'
                        | 'id'
                        | 'currency'
                        | 'pricingPlanType'
                        | 'status'
                        | 'description'
                      > & {
                          tiers?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'PricePlanTiers' } & Pick<
                                  PricePlanTiers,
                                  'floor' | 'ceiling' | 'amount' | 'unitAmount' | 'flatAmount'
                                >
                              >
                            >
                          >;
                        }
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchAvailablePromotionsForProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchAvailablePromotionsForProductQuery = { __typename?: 'Query' } & {
  nativeCatalogItem: { __typename?: 'Product' } & Pick<Product, 'id' | 'name'> & {
      availablePromotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              'id' | 'title' | 'status' | 'cycleInterval' | 'pricingType' | 'isPromotionCustomisable' | 'type'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'duration' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      > & {
                          customisable?: Maybe<
                            { __typename?: 'BenefitCustomisableObj' } & Pick<BenefitCustomisableObj, 'duration'> & {
                                value?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                                iterations?: Maybe<
                                  { __typename?: 'BenefitCustomisableValue' } & Pick<
                                    BenefitCustomisableValue,
                                    'type' | 'lowerBound' | 'upperBound'
                                  >
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
                applicationReason?: Maybe<
                  { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                      customisable?: Maybe<
                        { __typename?: 'PromotionReasonCustomisable' } & {
                          id?: Maybe<
                            { __typename?: 'PromotionReasonListObj' } & Pick<PromotionReasonListObj, 'type'> & {
                                anyOf?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'ReasonCustomisableObj' } & Pick<
                                        ReasonCustomisableObj,
                                        'readableName' | 'id'
                                      >
                                    >
                                  >
                                >;
                              }
                          >;
                        }
                      >;
                    }
                >;
                customisableReasons?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'ReasonCustomisableObj' } & Pick<ReasonCustomisableObj, 'readableName' | 'id'>>
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchNativeProductCatalogueQueryVariables = Exact<{ [key: string]: never }>;

export type FetchNativeProductCatalogueQuery = { __typename?: 'Query' } & {
  nativeCatalog?: Maybe<
    { __typename?: 'ProductConnection' } & {
      nodes: Array<
        Maybe<
          { __typename?: 'Product' } & Pick<
            Product,
            'id' | 'name' | 'productFamily' | 'productType' | 'updatedDate' | 'baseProduct'
          > & {
              addonParentProducts?: Maybe<
                Array<Maybe<{ __typename?: 'AddonParentProducts' } & Pick<AddonParentProducts, 'parentName'>>>
              >;
            }
        >
      >;
      pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
    }
  >;
};

export type FetchOfferingForProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchOfferingForProductQuery = { __typename?: 'Query' } & {
  nativeCatalogItem: { __typename?: 'Product' } & Pick<Product, 'id'> & {
      offering?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<Offering, 'id' | 'offeringName' | 'pricingType'> & {
                availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
              }
          >
        >
      >;
    };
};

export type FetchProductCatalogueV2QueryVariables = Exact<{ [key: string]: never }>;

export type FetchProductCatalogueV2Query = { __typename?: 'Query' } & {
  products?: Maybe<{ __typename?: 'ProductConnection' } & ProductsFieldsV2Fragment>;
};

export type ProductsFieldsV2Fragment = { __typename?: 'ProductConnection' } & Pick<ProductConnection, 'totalCount'> & {
    pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage'>;
    nodes: Array<
      Maybe<
        { __typename?: 'Product' } & Pick<Product, 'id' | 'name' | 'url' | 'currency'> & {
            plans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Plans' } & Pick<
                    Plans,
                    'id' | 'name' | 'pricingPlanType' | 'listPrice' | 'priceUpdated' | 'periodUnit'
                  >
                >
              >
            >;
          }
      >
    >;
  };

export type SearchProductCatalogueV2QueryVariables = Exact<{
  searchText?: Maybe<Scalars['String']>;
}>;

export type SearchProductCatalogueV2Query = { __typename?: 'Query' } & {
  searchProducts: { __typename?: 'ProductConnection' } & ProductsFieldsV2Fragment;
};

export type FetchProductCatalogueQueryVariables = Exact<{ [key: string]: never }>;

export type FetchProductCatalogueQuery = { __typename?: 'Query' } & {
  products?: Maybe<{ __typename?: 'ProductConnection' } & ProductsFieldsFragment>;
};

export type ProductsFieldsFragment = { __typename?: 'ProductConnection' } & Pick<ProductConnection, 'totalCount'> & {
    pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage'>;
    nodes: Array<
      Maybe<
        { __typename?: 'Product' } & Pick<Product, 'name' | 'url' | 'currency'> & {
            plans?: Maybe<
              Array<Maybe<{ __typename?: 'Plans' } & Pick<Plans, 'name' | 'listPrice' | 'priceUpdated' | 'periodUnit'>>>
            >;
          }
      >
    >;
  };

export type SearchProductCatalogueQueryVariables = Exact<{
  searchText?: Maybe<Scalars['String']>;
}>;

export type SearchProductCatalogueQuery = { __typename?: 'Query' } & {
  searchProducts: { __typename?: 'ProductConnection' } & ProductsFieldsFragment;
};

export type FetchSearchBasedAppsForProductsQueryVariables = Exact<{
  searchText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  pageParams?: Maybe<ProductPageParams>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type FetchSearchBasedAppsForProductsQuery = { __typename?: 'Query' } & {
  searchApps?: Maybe<
    { __typename?: 'SearchAppsProductsConnection' } & {
      nodes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'SearchAppsProducts' } & Pick<
              SearchAppsProducts,
              | 'id'
              | 'productKey'
              | 'status'
              | 'updatedDate'
              | 'offeringName'
              | 'pricingType'
              | 'pricingPlanKey'
              | 'pricingPlanLabel'
            > & { name: SearchAppsProducts['appName'] }
          >
        >
      >;
      pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
    }
  >;
};

export type SearchQuoteAuditNotesQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type SearchQuoteAuditNotesQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & {
    auditNotes?: Maybe<
      { __typename?: 'AuditNoteConnection' } & Pick<AuditNoteConnection, 'totalCount'> & {
          pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage'>;
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'AuditNote' } & Pick<
                  AuditNote,
                  'id' | 'key' | 'createdDate' | 'description' | 'status' | 'revisionNumber' | 'author'
                >
              >
            >
          >;
        }
    >;
  };
};

export type SearchQuoteRevisionQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

export type SearchQuoteRevisionQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & {
    revision?: Maybe<
      { __typename?: 'QuoteRevisionConnection' } & Pick<QuoteRevisionConnection, 'totalCount'> & {
          pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage'>;
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'QuoteRevision' } & Pick<
                  QuoteRevision,
                  'id' | 'revisionNumber' | 'createdDate' | 'quoteAuthor' | 'quoteNumber'
                >
              >
            >
          >;
        }
    >;
  };
};

export type FetchQuoteQueryQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type FetchQuoteQueryQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & Pick<
    Quote,
    | 'id'
    | 'quoteNumber'
    | 'name'
    | 'fromQuote'
    | 'transactionAccountId'
    | 'billingGroupId'
    | 'status'
    | 'quoteContact'
    | 'quoteAuthor'
    | 'createdDate'
    | 'expiryDate'
    | 'updatedDate'
    | 'finalizedDate'
    | 'total'
    | 'subTotal'
    | 'taxEstimate'
    | 'currency'
    | 'revisionNumber'
    | 'version'
    | 'estimateComputedAt'
    | 'estimateRequestedAt'
    | 'expiresAfterDays'
    | 'adminFee'
    | 'upgradeCredits'
  > & {
      shipTo?: Maybe<
        { __typename?: 'BillTo' } & Pick<
          BillTo,
          'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postalCode'
        >
      >;
      billTo?: Maybe<
        { __typename?: 'BillTo' } & Pick<
          BillTo,
          'companyName' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postalCode'
        >
      >;
      internalNotes?: Maybe<Array<Maybe<{ __typename?: 'Notes' } & Pick<Notes, 'note'>>>>;
      metadata?: Maybe<{ __typename?: 'QuoteMetaData' } & Pick<QuoteMetaData, 'quoteContact'>>;
      staleReason?: Maybe<
        { __typename?: 'StaleReason' } & Pick<StaleReason, 'code' | 'name' | 'lastUpdatedAt' | 'expiresAt'>
      >;
      cancelledReason?: Maybe<
        { __typename?: 'CancelledReason' } & Pick<CancelledReason, 'code' | 'name' | 'lastUpdatedAt'>
      >;
      lineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'QuoteLineItem' } & Pick<
              QuoteLineItem,
              | 'status'
              | 'lineItemId'
              | 'accountName'
              | 'description'
              | 'billingAnchorDate'
              | 'cloudSiteId'
              | 'cloudSiteHostname'
              | 'entitlementId'
              | 'entitlementNumber'
              | 'productKey'
              | 'offeringKey'
              | 'pricingPlanId'
              | 'entitlementVersion'
              | 'lineItemType'
              | 'quantity'
              | 'startDate'
              | 'endDate'
              | 'total'
              | 'subTotal'
              | 'taxEstimate'
              | 'billingFrequency'
              | 'userTierLabel'
              | 'promotionStatus'
              | 'discountTotal'
              | 'upgradeCredits'
            > & {
                billingAnchor?: Maybe<{ __typename?: 'BillingAnchor' } & Pick<BillingAnchor, 'type' | 'timestamp'>>;
                startsAt?: Maybe<{ __typename?: 'StartsAt' } & Pick<StartsAt, 'type'>>;
                endsAt?: Maybe<
                  { __typename?: 'EndsAt' } & Pick<EndsAt, 'type' | 'timestamp'> & {
                      duration?: Maybe<{ __typename?: 'Duration' } & Pick<Duration, 'interval' | 'intervalCount'>>;
                    }
                >;
                preBillingConfiguration?: Maybe<
                  { __typename?: 'PreBillingConfiguration' } & {
                    billFrom?: Maybe<{ __typename?: 'PreBillFrom' } & Pick<PreBillFrom, 'type'>>;
                    billTo?: Maybe<
                      { __typename?: 'PreBillTo' } & Pick<PreBillTo, 'type' | 'timestamp'> & {
                          duration?: Maybe<{ __typename?: 'Duration' } & Pick<Duration, 'interval' | 'intervalCount'>>;
                        }
                    >;
                  }
                >;
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'LineItemRelation' } & Pick<
                        LineItemRelation,
                        'relationshipType' | 'lineItemId' | 'referenceType' | 'entitlementId'
                      >
                    >
                  >
                >;
                pricingPlan?: Maybe<
                  { __typename?: 'LineItemPricingPlan' } & Pick<
                    LineItemPricingPlan,
                    'pricingPlanType' | 'billingFrequency'
                  >
                >;
                chargeQuantities?: Maybe<
                  Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'quantity' | 'chargeElement'>>>
                >;
                offerings?: Maybe<
                  Array<Maybe<{ __typename?: 'LineItemOffering' } & Pick<LineItemOffering, 'offeringName'>>>
                >;
                promotions?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Promotion' } & Pick<Promotion, 'promotionInstanceId' | 'type'> & {
                          promotionDefinition?: Maybe<
                            { __typename?: 'PromotionDefinition' } & Pick<
                              PromotionDefinition,
                              'promotionId' | 'promotionCode'
                            > & {
                                customisedValues?: Maybe<
                                  { __typename?: 'PromotionDefinitionValues' } & {
                                    benefits?: Maybe<
                                      Array<Maybe<{ __typename?: 'Benefit' } & Pick<Benefit, 'duration' | 'value'>>>
                                    >;
                                    applicationReason?: Maybe<
                                      { __typename?: 'PromotionApplicationReason' } & Pick<
                                        PromotionApplicationReason,
                                        'id'
                                      >
                                    >;
                                  }
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionDetails?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'PromotionDetail' } & Pick<
                        PromotionDetail,
                        | 'id'
                        | 'promotionCode'
                        | 'title'
                        | 'type'
                        | 'promotionInstanceId'
                        | 'status'
                        | 'cycleInterval'
                        | 'pricingType'
                        | 'cycleIntervalWithEligibleConditions'
                        | 'isPromotionCustomisable'
                      > & {
                          benefits?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'Benefit' } & Pick<
                                  Benefit,
                                  | 'benefitType'
                                  | 'duration'
                                  | 'subBenefitType'
                                  | 'iterations'
                                  | 'value'
                                  | 'scale'
                                  | 'type'
                                > & {
                                    customisable?: Maybe<
                                      { __typename?: 'BenefitCustomisableObj' } & Pick<
                                        BenefitCustomisableObj,
                                        'duration'
                                      > & {
                                          value?: Maybe<
                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                              BenefitCustomisableValue,
                                              'type' | 'lowerBound' | 'upperBound'
                                            >
                                          >;
                                          iterations?: Maybe<
                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                              BenefitCustomisableValue,
                                              'type' | 'lowerBound' | 'upperBound'
                                            >
                                          >;
                                        }
                                    >;
                                  }
                              >
                            >
                          >;
                          promotionWindow?: Maybe<
                            { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                          >;
                          eligibilityRules?: Maybe<
                            { __typename?: 'EligibilityRule' } & Pick<
                              EligibilityRule,
                              | 'products'
                              | 'cycleInterval'
                              | 'pricingType'
                              | 'partnerType'
                              | 'partnerTier'
                              | 'saleTransitionType'
                              | 'currency'
                            >
                          >;
                          applicationReason?: Maybe<
                            { __typename?: 'PromotionReason' } & Pick<PromotionReason, 'id' | 'readableName'> & {
                                customisable?: Maybe<
                                  { __typename?: 'PromotionReasonCustomisable' } & {
                                    id?: Maybe<
                                      { __typename?: 'PromotionReasonListObj' } & Pick<
                                        PromotionReasonListObj,
                                        'type'
                                      > & {
                                          anyOf?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'ReasonCustomisableObj' } & Pick<
                                                  ReasonCustomisableObj,
                                                  'readableName' | 'id'
                                                >
                                              >
                                            >
                                          >;
                                        }
                                    >;
                                  }
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                discountDetails?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'DiscountDetails' } & Pick<
                        DiscountDetails,
                        'promotionId' | 'discountAmount' | 'percentOff' | 'reasonCode' | 'discountType'
                      >
                    >
                  >
                >;
                taxItems?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'TaxDetails' } & Pick<TaxDetails, 'tax' | 'taxAmountLabel' | 'taxPercent'>>
                  >
                >;
                staleReason?: Maybe<
                  { __typename?: 'StaleReason' } & Pick<StaleReason, 'code' | 'name' | 'lastUpdatedAt' | 'expiresAt'>
                >;
                cancelledReason?: Maybe<
                  { __typename?: 'CancelledReason' } & Pick<CancelledReason, 'code' | 'name' | 'lastUpdatedAt'>
                >;
              }
          >
        >
      >;
    };
};

export type SearchQuotesQueryQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
  filterOptions?: Maybe<Array<Maybe<FilterOption>> | Maybe<FilterOption>>;
}>;

export type SearchQuotesQueryQuery = { __typename?: 'Query' } & {
  searchQuote?: Maybe<
    { __typename?: 'QuoteConnection' } & Pick<QuoteConnection, 'totalCount'> & {
        pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
        edges?: Maybe<
          Array<
            Maybe<
              { __typename?: 'QuoteEdge' } & {
                node?: Maybe<
                  { __typename?: 'Quote' } & Pick<
                    Quote,
                    | 'id'
                    | 'quoteNumber'
                    | 'transactionAccountId'
                    | 'status'
                    | 'quoteContact'
                    | 'quoteAuthor'
                    | 'createdDate'
                    | 'expiryDate'
                    | 'total'
                    | 'currency'
                    | 'revisionNumber'
                  > & {
                      billTo?: Maybe<
                        { __typename?: 'BillTo' } & Pick<
                          BillTo,
                          'companyName' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postalCode'
                        >
                      >;
                      transactionAccount?: Maybe<
                        { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'transactionAccountNumber'>
                      >;
                    }
                >;
              }
            >
          >
        >;
      }
  >;
};

export type TriggerQuoteReestimateQueryQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

export type TriggerQuoteReestimateQueryQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & Pick<Quote, 'reestimate'>;
};

export type FetchQuoteEstimatesQuery = { __typename?: 'Query' } & {
  quote: { __typename?: 'Quote' } & Pick<
    Quote,
    | 'id'
    | 'clonedFrom'
    | 'clonedQuoteNumber'
    | 'quoteNumber'
    | 'name'
    | 'contractType'
    | 'fromQuote'
    | 'transactionAccountId'
    | 'billingGroupId'
    | 'status'
    | 'quoteContact'
    | 'quoteAuthor'
    | 'updatedBy'
    | 'createdDate'
    | 'expiryDate'
    | 'updatedDate'
    | 'finalizedDate'
    | 'total'
    | 'subTotal'
    | 'taxEstimate'
    | 'currency'
    | 'revisionNumber'
    | 'version'
    | 'estimateComputedAt'
    | 'estimateRequestedAt'
    | 'expiresAfterDays'
    | 'adminFee'
    | 'upgradeCredits'
    | 'orderLink'
  > & {
      internalNotes?: Maybe<Array<Maybe<{ __typename?: 'Notes' } & Pick<Notes, 'note'>>>>;
      externalNotes?: Maybe<Array<Maybe<{ __typename?: 'Notes' } & Pick<Notes, 'note'>>>>;
      metadata?: Maybe<
        { __typename?: 'QuoteMetaData' } & Pick<
          QuoteMetaData,
          'ecc_aaids' | 'quoteContact' | 'contractType' | 'contractId'
        >
      >;
      opportunityDetail?: Maybe<
        { __typename?: 'OpportunityDetails' } & Pick<
          OpportunityDetails,
          | 'enterpriseAccountStatus'
          | 'ownerName'
          | 'owner'
          | 'ownerEmail'
          | 'ownerAAID'
          | 'accountRegion'
          | 'accountTerritory'
        > & { opportunityId: OpportunityDetails['id'] }
      >;
      staleReason?: Maybe<
        { __typename?: 'StaleReason' } & Pick<
          StaleReason,
          'code' | 'name' | 'lastUpdatedAt' | 'expiresAt' | 'orderId' | 'orderItemId'
        >
      >;
      cancelledReason?: Maybe<
        { __typename?: 'CancelledReason' } & Pick<
          CancelledReason,
          'code' | 'name' | 'lastUpdatedAt' | 'orderId' | 'orderItemId'
        >
      >;
      lineItems?: Maybe<
        Array<
          Maybe<
            { __typename?: 'QuoteLineItem' } & Pick<
              QuoteLineItem,
              | 'productKey'
              | 'orgId'
              | 'orgName'
              | 'status'
              | 'lineItemId'
              | 'accountName'
              | 'billingAnchorDate'
              | 'entitlementId'
              | 'offeringKey'
              | 'pricingPlanId'
              | 'lineItemType'
              | 'quantity'
              | 'startDate'
              | 'endDate'
              | 'total'
              | 'subTotal'
              | 'taxEstimate'
              | 'userTierLabel'
              | 'promotionStatus'
              | 'discountTotal'
              | 'marginTotal'
              | 'upgradeCredits'
            > & {
                billingAnchor?: Maybe<{ __typename?: 'BillingAnchor' } & Pick<BillingAnchor, 'type' | 'timestamp'>>;
                startsAt?: Maybe<{ __typename?: 'StartsAt' } & Pick<StartsAt, 'type' | 'timestamp'>>;
                productNote?: Maybe<
                  { __typename?: 'ProductNote' } & Pick<
                    ProductNote,
                    'id' | 'entitlementId' | 'entitlementNumber' | 'note' | 'productName' | 'productId'
                  >
                >;
                existingEnterpriseInstanceDetails?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'ExistingEnterpriseInstanceDetails' } & Pick<
                        ExistingEnterpriseInstanceDetails,
                        'productKey' | 'cloudSiteId'
                      >
                    >
                  >
                >;
                endsAt?: Maybe<
                  { __typename?: 'EndsAt' } & Pick<EndsAt, 'type' | 'timestamp'> & {
                      duration?: Maybe<{ __typename?: 'Duration' } & Pick<Duration, 'interval' | 'intervalCount'>>;
                    }
                >;
                preBillingConfiguration?: Maybe<
                  { __typename?: 'PreBillingConfiguration' } & {
                    billFrom?: Maybe<{ __typename?: 'PreBillFrom' } & Pick<PreBillFrom, 'type' | 'timestamp'>>;
                    billTo?: Maybe<
                      { __typename?: 'PreBillTo' } & Pick<PreBillTo, 'type' | 'timestamp'> & {
                          duration?: Maybe<{ __typename?: 'Duration' } & Pick<Duration, 'interval' | 'intervalCount'>>;
                        }
                    >;
                  }
                >;
                relatesFromEntitlements?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'LineItemRelation' } & Pick<
                        LineItemRelation,
                        'relationshipType' | 'lineItemId' | 'referenceType' | 'entitlementId'
                      >
                    >
                  >
                >;
                chargeQuantities?: Maybe<
                  Array<Maybe<{ __typename?: 'ChargeQuantity' } & Pick<ChargeQuantity, 'quantity' | 'chargeElement'>>>
                >;
                promotions?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Promotion' } & Pick<Promotion, 'promotionInstanceId' | 'type'> & {
                          promotionDefinition?: Maybe<
                            { __typename?: 'PromotionDefinition' } & Pick<
                              PromotionDefinition,
                              'promotionId' | 'promotionCode'
                            > & {
                                customisedValues?: Maybe<
                                  { __typename?: 'PromotionDefinitionValues' } & {
                                    benefits?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: 'Benefit' } & Pick<
                                            Benefit,
                                            'duration' | 'value' | 'iterations'
                                          >
                                        >
                                      >
                                    >;
                                    applicationReason?: Maybe<
                                      { __typename?: 'PromotionApplicationReason' } & Pick<
                                        PromotionApplicationReason,
                                        'id'
                                      >
                                    >;
                                  }
                                >;
                              }
                          >;
                        }
                    >
                  >
                >;
                promotionDetails?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'PromotionDetail' } & Pick<
                        PromotionDetail,
                        'id' | 'promotionCode' | 'title' | 'type'
                      >
                    >
                  >
                >;
                discountDetails?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'DiscountDetails' } & Pick<
                        DiscountDetails,
                        'promotionId' | 'discountAmount' | 'percentOff' | 'reasonCode' | 'discountType'
                      > & { period?: Maybe<{ __typename?: 'Period' } & Pick<Period, 'startsAt' | 'endsAt'>> }
                    >
                  >
                >;
                margins?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Margins' } & Pick<
                        Margins,
                        | 'promotionId'
                        | 'amount'
                        | 'percent'
                        | 'reasonCode'
                        | 'type'
                        | 'startsAt'
                        | 'endsAt'
                        | 'subTotal'
                        | 'blended'
                      > & {
                          blendedComputation?: Maybe<
                            { __typename?: 'BlendedComputation' } & Pick<
                              BlendedComputation,
                              | 'newGlp'
                              | 'previousGlp'
                              | 'upsellPercentage'
                              | 'renewPercentage'
                              | 'upsellValue'
                              | 'renewalValue'
                              | 'upsellMargin'
                              | 'renewalMargin'
                              | 'blendedMargin'
                            >
                          >;
                        }
                    >
                  >
                >;
                taxItems?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'TaxDetails' } & Pick<TaxDetails, 'tax' | 'taxAmountLabel' | 'taxPercent'>>
                  >
                >;
                staleReason?: Maybe<
                  { __typename?: 'StaleReason' } & Pick<
                    StaleReason,
                    'code' | 'name' | 'lastUpdatedAt' | 'expiresAt' | 'orderId' | 'orderItemId'
                  >
                >;
                cancelledReason?: Maybe<
                  { __typename?: 'CancelledReason' } & Pick<
                    CancelledReason,
                    'code' | 'name' | 'lastUpdatedAt' | 'orderId' | 'orderItemId'
                  >
                >;
                proratedCharges?: Maybe<
                  { __typename?: 'ProratedCharges' } & Pick<
                    ProratedCharges,
                    'subTotal' | 'credits' | 'discountTotal' | 'total' | 'users'
                  > & {
                      discountDetails?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'DiscountDetails' } & Pick<
                              DiscountDetails,
                              'promotionId' | 'discountAmount' | 'percentOff' | 'reasonCode' | 'discountType'
                            > & { period?: Maybe<{ __typename?: 'Period' } & Pick<Period, 'startsAt' | 'endsAt'>> }
                          >
                        >
                      >;
                      margins?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Margins' } & Pick<
                              Margins,
                              | 'promotionId'
                              | 'amount'
                              | 'percent'
                              | 'reasonCode'
                              | 'type'
                              | 'startsAt'
                              | 'endsAt'
                              | 'subTotal'
                              | 'blended'
                            > & {
                                blendedComputation?: Maybe<
                                  { __typename?: 'BlendedComputation' } & Pick<
                                    BlendedComputation,
                                    | 'newGlp'
                                    | 'previousGlp'
                                    | 'upsellPercentage'
                                    | 'renewPercentage'
                                    | 'upsellValue'
                                    | 'renewalValue'
                                    | 'upsellMargin'
                                    | 'renewalMargin'
                                    | 'blendedMargin'
                                  >
                                >;
                              }
                          >
                        >
                      >;
                      upgradeCreditDetails?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'UpgradeCreditDetails' } & Pick<
                              UpgradeCreditDetails,
                              'startsAt' | 'endsAt' | 'totalTax' | 'subTotal' | 'total' | 'invoiceRequestItemIds'
                            > & {
                                taxItems?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'TaxDetails' } & Pick<
                                        TaxDetails,
                                        'tax' | 'taxAmountLabel' | 'taxPercent'
                                      >
                                    >
                                  >
                                >;
                                margins?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Margins' } & Pick<
                                        Margins,
                                        'promotionId' | 'amount' | 'percent' | 'reasonCode' | 'type'
                                      >
                                    >
                                  >
                                >;
                              }
                          >
                        >
                      >;
                    }
                >;
                upgradeCreditDetails?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'UpgradeCreditDetails' } & Pick<
                        UpgradeCreditDetails,
                        'startsAt' | 'endsAt' | 'totalTax' | 'subTotal' | 'total' | 'invoiceRequestItemIds'
                      > & {
                          taxItems?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'TaxDetails' } & Pick<
                                  TaxDetails,
                                  'tax' | 'taxAmountLabel' | 'taxPercent'
                                >
                              >
                            >
                          >;
                          margins?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: 'Margins' } & Pick<
                                  Margins,
                                  'promotionId' | 'amount' | 'percent' | 'reasonCode' | 'type'
                                >
                              >
                            >
                          >;
                        }
                    >
                  >
                >;
              }
          >
        >
      >;
    };
};

export type FetchQuoteEstimatesQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  txaId?: Maybe<Scalars['String']>;
}>;
